webpackJsonp([23],{

/***/ "+IIN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__("8mnA");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__env__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__env__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__env__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__method__ = __webpack_require__("1KHg");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__method__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__method__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_1__method__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__related__ = __webpack_require__("5Z2C");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__related__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__related__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__related__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__related__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__related__["e"]; });




/***/ }),

/***/ "/rjl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bridgeReady;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("P/rs");
/**
 * DidiJSBridge 初始化
 * @author xuxiaoyan
 */


var cbs = [];

function iosInit() {
  if (window.DidiJSBridge && window.DidiJSBridge.init) {
    try {
      /**
       * 注意 init 只能调用一次，如果页面中调用多次，会抛出 error
       * 无法捕获这个 error，因为这个 error 是异步的
       */
      window.DidiJSBridge.init();
    } catch (e) {}
  }
}

function init() {

  if (window.DidiJSBridge) {
    __WEBPACK_IMPORTED_MODULE_0__util__["c" /* isIOS */] && iosInit();
  } else {
    document.addEventListener('DidiJSBridgeReady', onBridgeReady, false);
  }
}

function onBridgeReady() {
  __WEBPACK_IMPORTED_MODULE_0__util__["c" /* isIOS */] && iosInit();

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* each */])(cbs, function (cb) {
    cb(window.DidiJSBridge);
  });
}

setTimeout(function () {
  init();
});

/**
 * Hack for webview script
 * Fuck all of them
 */
window.Fusion = window.Fusion || {};
// window.DidiJSBridge = window.DidiJSBridge || {}
window.DidiBeatlesJSBridge = window.DidiBeatlesJSBridge || {};

function bridgeReady(callback) {
  if (window.DidiJSBridge) {
    // 注册回调事件
    callback(window.DidiJSBridge);
  } else {
    cbs.push(callback);
  }
}

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("WxI/");


/***/ }),

/***/ "0JGz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DDBridgeFinance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("P/rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ios__ = __webpack_require__("lsjZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__android__ = __webpack_require__("4dMp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ddbridge_app__ = __webpack_require__("0JXT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_bridge__ = __webpack_require__("/rjl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__("E0e7");
/**
 * 乘客端 DidiJSBridge 封装
 * @author huangyiustb
 * @modify liupei
 */








var DDBridgeFinance = {};

var defaultFn = function defaultFn() {};

function _call(method, param, callback) {
  if (__WEBPACK_IMPORTED_MODULE_0__util__["b" /* isAndroid */]) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__android__["a" /* callAndroid */])(method, param, callback);
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ios__["a" /* callIOS */])(method, param, callback);
  }
}

function call(method, param, callback) {
  // _call(method, param, callback)
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* invokeInTurn */])(_call, arguments);
}

/**
 * 根据config创建JSBridge方法
 * @param conf 配置文件
 * @returns {Function}
 */
function passengerBridgeFn(name, conf, isOldVersion) {
  return function () {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFn;


    if (arguments.length === 1 && typeof param === 'function') {
      callback = param;
      param = {};
    }

    // 根据版本号区分ddbridge和echo
    // http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=75128588
    var method = name,
        isAndlite = __WEBPACK_IMPORTED_MODULE_0__util__["b" /* isAndroid */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__ddbridge_app__["a" /* compareAppVersion */])('>=', '5.0.0'),
        isIoslite = __WEBPACK_IMPORTED_MODULE_0__util__["c" /* isIOS */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__ddbridge_app__["a" /* compareAppVersion */])('>=', '5.0.0');

    // if (!isOldVersion && (isIoslite || isAndlite)) {
    if (true) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* logger */])({
        pos: 'CALL_BRIDGE',
        version: '5.x',
        method: method
      });
      call(method, param, callback);
    } else {

      // if (conf && conf.fn) {
      //   method = conf.fn
      // }
      // setTimeout(() => { // hack
      //   bridgeReady((bridge) => {
      //     bridge.callHandler(method, param, data => {

      //       if (typeof data == 'string') {
      //         data = JSON.parse(data)
      //       }

      //       callback(null, data)
      //     })
      //   })
      // }, 0)

      // logger({
      //   pos: 'callBridge',
      //   version: '4.x',
      //   method
      // })
    }
  };
}

/**
 * 滴滴金融端基础的Bridge.call(method, param, callback)方法
 * @param DDBridge
 */
function initFinanceBaseCall(DDBridge) {
  // isOldVersion 强制使用老版本ddbridge
  DDBridge.call = function (method, param, callback, isOldVersion) {
    var conf = __WEBPACK_IMPORTED_MODULE_5__config__["c" /* financeConfig */][method],
        bridgeFn = passengerBridgeFn(method, conf, isOldVersion);

    if (!callback && typeof param === 'function') {
      callback = param;
      param = {};
    }
    return bridgeFn(param, callback);
  };
  return DDBridge;
}

initFinanceBaseCall(DDBridgeFinance);



/***/ }),

/***/ "0JXT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return app; });
/* harmony export (immutable) */ __webpack_exports__["b"] = initApp;
/* unused harmony export inApp */
/* harmony export (immutable) */ __webpack_exports__["a"] = compareAppVersion;
/* harmony export (immutable) */ __webpack_exports__["c"] = compareSysVersion;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("P/rs");
/**
 * 版本的封装
 * @author huangyiustb
 * @email huangyiustb@didichuxing.com
 */



var appRE = /didi\.(\w+)[\s\/]([\d\.]+)/,
    androidAppREG = /didigsui.*_(.+)_\d+$/ig,
    iOSAppREG = /ddudriver.*_(.+)$/ig,
    daijiaAppREG = /(daijia\.\w+)[\s\/]([\d\.]+)/ig,
    financeAppREG = /(finance\.\w+)[\s\/]([\d\.]+)/ig;
var UNKNOWN = 'unknown';

// 判断是否是 主端 顺风车容器
var inBeatles = function inBeatles(ua) {
  return (/didi\.passenger.+beatles/i.test(ua)
  );
};

// 判断是否是 顺丰独立端 容器
var inBlord = function inBlord(ua) {
  return (/didi\.passenger.+beatles\sblord/i.test(ua)
  );
};

var app = {};

function initApp(DDBridge) {
  var matches = __WEBPACK_IMPORTED_MODULE_0__util__["f" /* UA */].match(appRE) || daijiaAppREG.exec(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* UA */]) || financeAppREG.exec(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* UA */]),
      otherMatches = androidAppREG.exec(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* UA */]) || iOSAppREG.exec(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* UA */]);
  var env = UNKNOWN;
  var version = UNKNOWN;
  if (matches) {
    env = matches[1];
    version = matches[2];
  } else if (otherMatches) {
    env = otherMatches[0];
    version = otherMatches[1];
  }

  // 主端 但是 是 顺风车的 web 容器
  if (inBlord(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* UA */])) {
    // 独立端
    env = 'blord';
    version = matches[2];
    // version =
  } else if (inBeatles(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* UA */])) {
    // 滴滴乘客端顺风车webview内
    env = 'beatles';
    version = matches[2];
  }

  var system = __WEBPACK_IMPORTED_MODULE_0__util__["c" /* isIOS */] ? 'ios' : __WEBPACK_IMPORTED_MODULE_0__util__["b" /* isAndroid */] ? 'android' : UNKNOWN;
  var sysVersion = __WEBPACK_IMPORTED_MODULE_0__util__["c" /* isIOS */] ? __WEBPACK_IMPORTED_MODULE_0__util__["g" /* iosVersion */] : __WEBPACK_IMPORTED_MODULE_0__util__["b" /* isAndroid */] ? __WEBPACK_IMPORTED_MODULE_0__util__["h" /* androidVersion */] : UNKNOWN;

  DDBridge.app = app = {
    env: env,
    version: version,
    system: system,
    sysVersion: sysVersion,
    driver: !!otherMatches
  };
}

function inApp() {
  return app.env && app.env !== UNKNOWN;
};

function compareAppVersion() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  switch (args.length) {
    case 2:
      return compare(app.version, args[0], args[1]);
    case 3:
      return compare.apply(null, args);
  }
}

function compareSysVersion() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  switch (args.length) {
    case 2:
      return compare(app.sysVersion, args[0], args[1]);
    case 3:
      return compare.apply(null, args);
  }
}

function compare(v1, symbol, v2) {
  v1 = parse(v1);
  v2 = parse(v2);
  if (symbol.indexOf('=') !== -1 && v1 === v2) {
    return true;
  }
  if (symbol.indexOf('>') !== -1 && v1 > v2) {
    return true;
  }
  if (symbol.indexOf('<') !== -1 && v1 < v2) {
    return true;
  }
  return false;
}

function parse() {
  var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  version = version.split('.');
  version.length = 4;

  var ret = [];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* each */])(version, function (n) {
    n = n * 1;
    if (n) {
      ret.push(n >= 10 ? n : '0' + n);
    } else {
      ret.push('00');
    }
  });
  return parseInt(ret.join(''), 10);
}

/***/ }),

/***/ "0y8L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isAndroid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isIOS; });
/* unused harmony export isFusion */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return iosVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return androidVersion; });
/**
 * 浏览器环境相关
 * @author huangyiustb
 * @email huangyiustb@didichuxing.com
 */
var UA = window.navigator.userAgent.toLowerCase();

var isAndroid = /android/i.test(UA);

var isIOS = /iphone os/i.test(UA);

var isFusion = /fusionkit/i.test(UA);

var iosRE = /iphone os ([\d_]+)/i;
var androidRE = /android[ /]([\d\.]+)/i;

var iosVersion = function () {
  var version = '';
  if (isIOS) {
    var match = UA.match(iosRE);
    version = match[1];
  }
  return version.replace(/_/g, '.');
}();

var androidVersion = function () {
  var version = '';
  if (isAndroid) {
    var match = UA.match(androidRE);
    version = match[1];
  }
  return version;
}();

/***/ }),

/***/ "1G11":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return events; });
/**
 *  事件管理中心，用于监听，派发事件
 *  @author huangyiustb
 *  @email huangyiustb@didichuxing.com
 */
var _listenerMap = {};

function call(callback, args) {
	var fn = callback[0];
	var context = callback[1];
	args = callback[2].concat(args);
	try {
		return fn.apply(context, args);
	} catch (e) {
		setTimeout(function () {
			throw e;
		}, 0);
	}
}

function arrayClone(arr, len) {
	var copy = new Array(len);
	while (len--) {
		copy[len] = arr[len];
	}
	return copy;
}

function _emit(type) {
	var listenerList = _listenerMap[type];
	if (!listenerList) {
		return true;
	}
	var len = listenerList.cbs.length;
	var cbs = arrayClone(listenerList.cbs, len);
	var ret = true;

	for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		args[_key - 1] = arguments[_key];
	}

	for (var index = 0; index < len; index++) {
		if (!cbs[index]) {
			continue;
		}
		ret = call(cbs[index], args) !== false && ret;
	}
	return !!ret;
}

var events = {
	on: function on(type, fn, context) {
		var listenerList = _listenerMap[type];
		if (!listenerList) {
			_listenerMap[type] = listenerList = {
				args: null,
				cbs: []
			};
		}

		for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
			rest[_key2 - 3] = arguments[_key2];
		}

		var callback = [fn, context, rest];
		var args = listenerList.args;
		if (args) {
			call(callback, args);
		} else {
			listenerList.cbs.push(callback);
		}
	},
	un: function un(type, fn) {
		var listenerList = _listenerMap[type];
		if (!listenerList) {
			return true;
		}
		if (arguments.length === 1) {
			listenerList.cbs = [];
		} else {
			var cbs = listenerList.cbs;
			var count = cbs.length;
			while (count--) {
				if (cbs[count] && cbs[count][0] === fn) {
					cbs.splice(count, 1);
				}
			}
		}
	},
	emit: function emit(type, args) {
		return _emit.apply(this, arguments);
	},
	done: function done(type) {
		for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
			args[_key3 - 1] = arguments[_key3];
		}

		var listenerList = _listenerMap[type];
		if (!listenerList) {
			_listenerMap[type] = listenerList = {
				args: args,
				cbs: []
			};
		}
		var cbs = listenerList.cbs;
		var count = cbs.length;
		_emit.apply(this, arguments);

		listenerList.args = args;
		listenerList.cbs = cbs.slice(count);
	},
	undo: function undo(type) {
		var listenerList = _listenerMap[type];
		if (!listenerList) {
			return false;
		}
		listenerList.args = null;
	}
};

/***/ }),

/***/ "1KHg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extendSimple;
/* harmony export (immutable) */ __webpack_exports__["d"] = obj2Query;
/* harmony export (immutable) */ __webpack_exports__["b"] = noop;
/* harmony export (immutable) */ __webpack_exports__["c"] = ajax;
/* unused harmony export params */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);


/**
 * 扩展obj
 * @param dest
 * @param obj
 * @returns {*}
 */
function extendSimple(dest, obj) {
  dest = dest || {};
  for (var i in obj) {
    dest[i] = obj[i];
  }
  return dest;
}

/**
 * 对象转query
 * @param obj
 * @returns {string}
 */
function obj2Query(obj) {
  var query = '';
  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).forEach(function (key, index) {
    var ifAnd = index === 0 ? '' : '&';
    query = query + ifAnd + key + '=' + encodeURIComponent(obj[key]);
  });
  return query;
}

/**
 * 空函数
 */
function noop() {}

/**
 * 简单封装ajax
 * @param {option} obj 同jq的ajax参数
 */
function ajax(obj) {
  var xhr = new window.XMLHttpRequest();

  // default get
  if (!obj.method) {
    obj.method = 'get';
  }

  // get
  if (obj.method === 'get') {
    obj.data = params(obj.data);
    obj.url += (obj.url.indexOf('?') === -1 ? '?' : '&') + obj.data;
  }

  // cache
  if (obj.cache !== true) {
    obj.url += (obj.url.indexOf('?') === -1 ? '?' : '&') + '_=' + new Date().getTime();
  }

  // async
  obj.async = obj.async !== false;
  if (obj.async !== false) {
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        callback();
      }
    };
  }

  xhr.open(obj.method, obj.url, obj.async);

  // 增加header信息
  if (obj.headers) {
    for (var header in obj.headers) {
      xhr.setRequestHeader(header, obj.headers[header]);
    }
  } else {
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  }

  if (obj.method === 'post') {
    xhr.send(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj.data));
  } else {
    xhr.send(null);
  }

  // 同步
  if (obj.async === false) {
    callback();
  }

  function callback() {
    if (xhr.status === 200) {
      var response = xhr.responseText;
      if (obj.dataType === 'json') {
        response = JSON.parse(response);
      }
      obj.success && obj.success(response);
    } else {
      obj.error && obj.error(xhr.status, xhr.statusText);
    }
  }
}

/**
 * 名值对转换为字符串 如{name:'jalon', age: 23} => name=jalon&age=23
 * @param {对象} data
 */
function params(data) {
  var arr = [];
  for (var i in data) {
    // 特殊字符传参产生的问题可以使用encodeURIComponent()进行编码处理
    arr.push(encodeURIComponent(i) + '=' + encodeURIComponent(data[i]));
  }
  return arr.join('&');
}

/***/ }),

/***/ "3KX6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DDBridgePassenger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("P/rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ios__ = __webpack_require__("LGhb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__android__ = __webpack_require__("a+k9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ddbridge_app__ = __webpack_require__("0JXT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_bridge__ = __webpack_require__("/rjl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__("E0e7");
/**
 * 乘客端 DidiJSBridge 封装
 * @author huangyiustb
 * @modify xuxiaoyan
 */








var DDBridgePassenger = {};

var defaultFn = function defaultFn() {};

//通过初始化注册客户端事件回调Handler
//http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=75128588

// function init() {
// 	let triggerName = '__bridgeTrigger__'
//
// 	window[triggerName] = function (retData) {
// 		if (typeof retData === 'string') {
// 			try {
// 				retData = JSON.parse(retData)
// 			} catch (e) {
// 				retData = {}
// 			}
// 		}
// 		let eventName = retData.eventname
// 		let errno = retData.errno
// 		let err = null
//
// 		if (errno !== ERR_OK) {
// 			let msg = retData.errmsg
// 			err = new Error(msg)
// 		}
//
// 		events.emit(eventName, err, retData.result)
// 	}
//
// 	call('initConfig', {
// 		handler: triggerName
// 	}, '')
// }
//
// init()

function _call(method, param, callback) {
  if (__WEBPACK_IMPORTED_MODULE_0__util__["b" /* isAndroid */]) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__android__["a" /* callAndroid */])(method, param, callback);
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__ios__["a" /* callIOS */])(method, param, callback);
  }
}

function call(method, param, callback) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* invokeInTurn */])(_call, arguments);
}

/**
 * 根据config创建JSBridge方法
 * @param conf 配置文件
 * @returns {Function}
 */
function passengerBridgeFn(name, conf, isOldVersion) {
  return function () {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFn;


    if (arguments.length === 1 && typeof param === 'function') {
      callback = param;
      param = {};
    }

    // 根据版本号区分ddbridge和echo
    // http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=75128588
    var method = name,
        isAndlite = __WEBPACK_IMPORTED_MODULE_0__util__["b" /* isAndroid */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__ddbridge_app__["a" /* compareAppVersion */])('>=', '5.0.0'),
        isIoslite = __WEBPACK_IMPORTED_MODULE_0__util__["c" /* isIOS */] && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__ddbridge_app__["a" /* compareAppVersion */])('>=', '5.0.0');

    if (!isOldVersion && (isIoslite || isAndlite)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* logger */])({
        pos: 'CALL_BRIDGE',
        version: '5.x',
        method: method
      });
      call(method, param, callback);
    } else {

      if (conf && conf.fn) {
        method = conf.fn;
      }
      setTimeout(function () {
        // hack
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_bridge__["a" /* bridgeReady */])(function (bridge) {
          bridge.callHandler(method, param, function (data) {

            if (typeof data == 'string') {
              data = JSON.parse(data);
            }

            callback(null, data);
          });
        });
      }, 0);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* logger */])({
        pos: 'callBridge',
        version: '4.x',
        method: method
      });
    }
  };
}

/**
 * 乘客端基础的Bridge.call(method, param, callback)方法
 * @param DDBridge
 */
function initPassengerBaseCall(DDBridge) {
  // isOldVersion 强制使用老版本ddbridge
  DDBridge.call = function (method, param, callback, isOldVersion) {
    var conf = __WEBPACK_IMPORTED_MODULE_5__config__["d" /* passengerConfig */][method],
        bridgeFn = passengerBridgeFn(method, conf, isOldVersion);

    if (!callback && typeof param === 'function') {
      callback = param;
      param = {};
    }

    return bridgeFn(param, callback);
  };
  return DDBridge;
}

initPassengerBaseCall(DDBridgePassenger);



/***/ }),

/***/ "3NZO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return aliasWithBridge4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return aliasWithBridge5; });

/**
 * beatles bridge部分方法对应bridge4中的方法
 * http://fe.in.didialift.com:8088/fe/hudamin/didibridge.md.html
 * http://fe.in.didialift.com:8088/fe/hudamin/jsbridge.md.html
 */
var aliasWithBridge4 = {
  openUrl: 'open_url',
  uploadImageBySelect: 'callbackImageLiteratureReview',
  uploadImageByCamera: 'callbackImageLiteratureReviewTakeCamera',
  uploadImageByPhotoLibrary: 'callbackImageLiteratureReviewPhotoLibrary'
};

/**
 * beatles bridge部分方法对应bridge5中的方法 使用回调
 * http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=94909837
 */
var aliasWithBridge5 = {
  shareWxAppmsg: 'shareWeixinAppmsg',
  shareWxTimeline: 'shareWeixinTimeline',
  shareQQAppmsg: 'shareQqAppmsg',
  shareQZone: 'shareQzone',
  shareSinaWeibo: 'shareSinaWeibo'
};



/***/ }),

/***/ "3OnU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extendBeatlesAPI;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("+IIN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("pMqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__schemes__ = __webpack_require__("cemT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__call__ = __webpack_require__("N7kH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__alias__ = __webpack_require__("3NZO");
/**
 * 对bridge扩展或处理顺风车bridge相关API 支持情况见文档
 * wiki-beatles-bridge-API bridge: http://fe.in.didialift.com:8088/fe/hudamin/didibridge.md.html#nav_24
 * wiki-beatles-beatlesCommunicate-API bridge: http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=79447904
 * wiki-common bridge: http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=94909837
 */



var theWindow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["getWindow"])();





// 需要别名处理的方法


/**
 * 支持顺风车bridge特殊方法
 * 以下方法为顺风车使用bridge需要处理或补充的方法，保证bridge方法均可用。其他未提到的bridge方法（如getUserInfo等）均为可用，
 * 只在callback里做了返回参数兼容，在此不做处理。
 * 需要必须走老协议（4.x）的请使用callHandler
 * @param DDbridge
 */
function extendBeatlesAPI(DDbridge) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* extendSimple */])(DDbridge, {
    schemes: __WEBPACK_IMPORTED_MODULE_2__schemes__["a" /* default */],
    callHandler: __WEBPACK_IMPORTED_MODULE_3__call__["a" /* callHandler */],
    callNative: __WEBPACK_IMPORTED_MODULE_3__call__["b" /* callNative */],
    listenNative: __WEBPACK_IMPORTED_MODULE_3__call__["c" /* listenNative */],
    beatlesCommunicate: __WEBPACK_IMPORTED_MODULE_3__call__["d" /* beatlesCommunicate */],
    check: DDbridge.support,
    appVersion: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["b" /* getAppVersion */])(DDbridge.app.version),
    compareVersion: __WEBPACK_IMPORTED_MODULE_0__util__["c" /* compareVersion */],
    updateNaviTitle: function updateNaviTitle(titleObj) {
      DDbridge.setTitle({
        title: titleObj.navi_title || titleObj.title
      });
    },
    /**
     * 安卓使用自己协议的登录 callNative('callNativeLogin', {}, cb)，平台回回到首页弹登录框，不符合业务
     * iOS使用平台方法
     */
    callNativeLoginWithCallback: function callNativeLoginWithCallback(cb) {
      cb = cb || __WEBPACK_IMPORTED_MODULE_0__util__["d" /* noop */];
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* isFusionKit */])()) {
        DDbridge.call('callNativeLoginWithCallback', {
          needStopReload: true
        }, cb);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__call__["a" /* callHandler */])('callNativeLoginWithCallback', {
          needStopReload: true
        }, cb);
      }
    },
    openUrl: function openUrl(params) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__call__["a" /* callHandler */])(__WEBPACK_IMPORTED_MODULE_4__alias__["a" /* aliasWithBridge4 */]['openUrl'], params);
    },
    initEntrance: function initEntrance(opts, cb) {
      var me = this;
      me.cb = cb || __WEBPACK_IMPORTED_MODULE_0__util__["d" /* noop */];
      me.opts = opts || {};
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* isIos */])()) {
        theWindow['__showEntranceCallBack__'] = cb || function () {};
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* extendSimple */])(opts, {
          'windowCallBack': '__showEntranceCallBack__'
        });
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["g" /* entranceConfigAlias */])(opts);
      DDbridge.call('initEntrance', opts, cb);
    },
    /**
     * 必须先initEntrance，才能有回调，端上bug
     */
    showEntrance: function showEntrance() {
      var me = this;
      if (!me.opts) {
        throw new Error('请先initEntrance');
      }
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["f" /* isIos */])()) {
        theWindow['__showEntranceCallBack__'] = me.cb || function () {};
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* extendSimple */])(me.opts, {
          'windowCallBack': '__showEntranceCallBack__'
        });
      }
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["g" /* entranceConfigAlias */])(me.opts);

      // 需要延迟才能和initEntrance生效
      setTimeout(function () {
        DDbridge.call('showEntrance', me.opts, me.cb);
      }, 300);
    },
    // 延迟隐藏，因为showEntrance延迟了
    hideEntrance: function hideEntrance() {
      setTimeout(function () {
        DDbridge.call('hideEntrance');
      }, 360);
    },
    invokeEntrance: function invokeEntrance() {
      var me = this;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["g" /* entranceConfigAlias */])(me.opts);
      DDbridge.call('invokeEntrance', me.opts, me.cb);
    },
    // 以下直接渠道分享，需要先initEntrance或showEntrance才可触发回调，ios实现bug，回调用这里的回调。。坑。
    shareWxAppmsg: function shareWxAppmsg(shareConfig, cb) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["h" /* shareConfigAlias */])(shareConfig);
      DDbridge.call(__WEBPACK_IMPORTED_MODULE_4__alias__["b" /* aliasWithBridge5 */]['shareWxAppmsg'], shareConfig, cb);
    },
    shareWxTimeline: function shareWxTimeline(shareConfig, cb) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["h" /* shareConfigAlias */])(shareConfig);
      DDbridge.call(__WEBPACK_IMPORTED_MODULE_4__alias__["b" /* aliasWithBridge5 */]['shareWxTimeline'], shareConfig, cb);
    },
    shareQQAppmsg: function shareQQAppmsg(shareConfig, cb) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["h" /* shareConfigAlias */])(shareConfig);
      DDbridge.call(__WEBPACK_IMPORTED_MODULE_4__alias__["b" /* aliasWithBridge5 */]['shareQQAppmsg'], shareConfig, cb);
    },
    shareQZone: function shareQZone(shareConfig, cb) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["h" /* shareConfigAlias */])(shareConfig);
      DDbridge.call(__WEBPACK_IMPORTED_MODULE_4__alias__["b" /* aliasWithBridge5 */]['shareQZone'], shareConfig, cb);
    },
    shareSinaWeibo: function shareSinaWeibo(shareConfig, cb) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["h" /* shareConfigAlias */])(shareConfig);
      DDbridge.call(__WEBPACK_IMPORTED_MODULE_4__alias__["b" /* aliasWithBridge5 */]['shareSinaWeibo'], shareConfig, cb);
    },
    uploadImageBySelect: function uploadImageBySelect(config, cb) {
      var uploadCb = 'uploadCallback' + Date.now();
      theWindow[uploadCb] = cb || __WEBPACK_IMPORTED_MODULE_0__util__["d" /* noop */];
      config.callback = uploadCb;
      config.outputWidth = config.outputWidth || 800;
      config.outputHeight = config.outputHeight || 800;
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* isFusionKit */])()) {
        DDbridge.call(__WEBPACK_IMPORTED_MODULE_4__alias__["a" /* aliasWithBridge4 */]['uploadImageBySelect'], config, theWindow[uploadCb]);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__call__["a" /* callHandler */])(__WEBPACK_IMPORTED_MODULE_4__alias__["a" /* aliasWithBridge4 */]['uploadImageBySelect'], config, theWindow[uploadCb]);
      }
    },
    uploadImageByCamera: function uploadImageByCamera(config, cb) {
      var uploadCb = 'uploadCallback' + Date.now();
      theWindow[uploadCb] = cb || __WEBPACK_IMPORTED_MODULE_0__util__["d" /* noop */];
      config.callback = uploadCb;
      config.outputWidth = config.outputWidth || 800;
      config.outputHeight = config.outputHeight || 800;
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* isFusionKit */])()) {
        DDbridge.call(__WEBPACK_IMPORTED_MODULE_4__alias__["a" /* aliasWithBridge4 */]['uploadImageByCamera'], config, theWindow[uploadCb]);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__call__["a" /* callHandler */])(__WEBPACK_IMPORTED_MODULE_4__alias__["a" /* aliasWithBridge4 */]['uploadImageByCamera'], config, theWindow[uploadCb]);
      }
    },
    uploadImageByPhotoLibrary: function uploadImageByPhotoLibrary(config, cb) {
      var uploadCb = 'uploadCallback' + Date.now();
      theWindow[uploadCb] = cb || __WEBPACK_IMPORTED_MODULE_0__util__["d" /* noop */];
      config.callback = uploadCb;
      config.outputWidth = config.outputWidth || 800;
      config.outputHeight = config.outputHeight || 800;
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["e" /* isFusionKit */])()) {
        DDbridge.call(__WEBPACK_IMPORTED_MODULE_4__alias__["a" /* aliasWithBridge4 */]['uploadImageByPhotoLibrary'], config, theWindow[uploadCb]);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__call__["a" /* callHandler */])(__WEBPACK_IMPORTED_MODULE_4__alias__["a" /* aliasWithBridge4 */]['uploadImageByPhotoLibrary'], config, theWindow[uploadCb]);
      }
    },

    /**
     * 端上后来兼容的方法
     * var eventkey = 'entranceAndroidBugCallback_' + new Date().getTime();
     * Didibridge.showEntranceAndroidBug({
     *     windowCallBack: eventkey
     * });
     */
    showEntranceAndroidBug: function showEntranceAndroidBug(opt) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__call__["a" /* callHandler */])('showEntranceAndroidBug', opt);
    },

    // mock data out of didi app
    getSystemInfo: function getSystemInfo(cb) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["i" /* mockOrCall */])(DDbridge, 'getSystemInfo', {}, cb);
    },
    getLocationInfo: function getLocationInfo(cb) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["i" /* mockOrCall */])(DDbridge, 'getLocationInfo', {}, cb);
    },
    getUserInfo: function getUserInfo(cb) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["i" /* mockOrCall */])(DDbridge, 'getUserInfo', {}, cb);
    },
    startRecognition: function startRecognition(opts, cb) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["i" /* mockOrCall */])(DDbridge, 'startRecognition', opts, cb);
    },
    stopRecognition: function stopRecognition(opts, cb) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["i" /* mockOrCall */])(DDbridge, 'stopRecognition', opts, cb);
    },
    cancelRecognition: function cancelRecognition(opts, cb) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["i" /* mockOrCall */])(DDbridge, 'cancelRecognition', opts, cb);
    },
    startRecord: function startRecord(opts, cb) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["i" /* mockOrCall */])(DDbridge, 'startRecord', opts, cb);
    },
    endRecord: function endRecord(opts, cb) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["i" /* mockOrCall */])(DDbridge, 'endRecord', opts, cb);
    }
  });
}

/***/ }),

/***/ "3Ufk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DDBridgeDaijiaDriver */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("P/rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("E0e7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ios__ = __webpack_require__("EiWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__android__ = __webpack_require__("AEMj");
/**
 * 代驾端 DidiJSBridge 封装
 * 参考：https://git-hz.xiaojukeji.com/kui/native/tree/master
 * 吐槽下代驾... 我 ^%@!%$*
 * @author linkFly(jianglai@didichuxing.com)
 */

// 代驾可调用的 API 文档： http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=38710326







var DDBridgeDaijiaDriver = {};

var defaultFn = function defaultFn() {};

function call(method) {
  var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultFn;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* invokeInTurn */])(_call, arguments);
}

function _call(method) {
  var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultFn;

  if (__WEBPACK_IMPORTED_MODULE_0__util__["b" /* isAndroid */]) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__android__["a" /* default */])(method, param, callback);
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__ios__["a" /* default */])(method, param, callback);
  }
}

/**
 * 根据config创建JSBridge方法
 * @param conf 配置文件
 * @returns {Function}
 */
function wrapBridgeFn(name, conf, args) {
  return function () {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFn;


    if (arguments.length === 1 && typeof param === 'function') {
      callback = param;
      param = {};
    }

    var method = conf ? conf.fn : name;
    var prepare = conf ? conf.prepare : null;

    // 是否支持该方法判断
    // 暂时缺省

    if (prepare && typeof prepare === 'function') {
      call.apply(null, prepare.apply(null, args));
    } else if (name) {
      call(method, param, callback);
    }
  };
}

/**
 * 司机端基础的Bridge.call(method, param, callback)方法
 * @param DDBridge
 */
function initDriverBaseCall(DDBridge) {
  DDBridge.call = function (method) {
    var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultFn;


    var conf = __WEBPACK_IMPORTED_MODULE_1__config__["a" /* daijiaConfig */][method],
        args = Array.prototype.slice.call(arguments, 0),
        bridgeFn = wrapBridgeFn(method, conf, args);

    if ((!callback || callback === defaultFn) && typeof param === 'function') {
      callback = param;
      param = {};
    }

    return bridgeFn(param, callback);
  };
}

initDriverBaseCall(DDBridgeDaijiaDriver);



/***/ }),

/***/ "3ytO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_735e9af3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("L5nL");
function injectStyle (ssrContext) {
  __webpack_require__("6MXA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_735e9af3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4dMp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = callAndroid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_index__ = __webpack_require__("P/rs");

/**
 * prompt 封装, Andrid大于4.2.0版本均可以用
 * @author huangyiustb
 * @modify xuxiaoyan
 * http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=75128588
 */



var __uid = 0;

function callAndroid(fn, param, callback) {
  var id = __uid++;
  var callbackName = '__bridgeCall__' + id;

  var message = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    cmd: fn,
    id: id,
    params: param,
    callback: callbackName
  });

  window[callbackName] = function (retData) {
    var errno = retData.errno;
    var err = null;
    if (errno !== __WEBPACK_IMPORTED_MODULE_1__util_index__["i" /* ERR_OK */]) {
      var msg = retData.errmsg;
      err = { errno: retData.errno, errmsg: retData.errmsg };
    }
    // 分享面板会统一执行这个回调
    fn !== 'showEntrance' && delete window[callbackName];

    // node style
    callback(err, retData.result || retData);
  };

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_index__["e" /* logger */])({
    pos: 'ANDROID_SEND_MSG',
    message: message
  });

  window.prompt(message);
}

// export const supportPrompt = isAndroid && compareVersion('>4.2.0');

/***/ }),

/***/ "4gy1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initIS;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("P/rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__("0JXT");
/**
 * is方法的实现, 类似media query的bnf
 * tokenize + parse
 * BNF:
 * rule_list: <rule>[,<rule>]*
 * rule: <expression>[and <expression>]*
 * expression:(<identity>[<operator><version>]?)
 * identity:ios|android|passenger|driver|lite
 * operator: > | < | = | >= | <=
 * version: [\d\.]
 * @author huangyiustb
 * @email huangyiustb@didichuxing.com
 */




var identRE = /^\w+(\.\w+)?/;
var versionRE = /^[\d\._]+/;
var opRE = /^\s*[>=<]+\s*/;
var commaRE = /^\s*,\s*/;
var andRE = /^\s*and\s*/;

var ERR_IDENTITY = 0;
var ERR_VERSION = 1;

var errMsg = ['identity is not valid', 'version is not valid'];

var SYSTEM = 0;
var APP = 1;

var identityList = {
  passenger: {
    type: APP,
    compare: __WEBPACK_IMPORTED_MODULE_1__app__["a" /* compareAppVersion */]
  },
  driver: {
    type: APP,
    compare: __WEBPACK_IMPORTED_MODULE_1__app__["a" /* compareAppVersion */]
  },
  finance: {
    type: APP,
    compare: __WEBPACK_IMPORTED_MODULE_1__app__["a" /* compareAppVersion */]
  },
  'daijia.driver': {
    type: APP,
    compare: __WEBPACK_IMPORTED_MODULE_1__app__["a" /* compareAppVersion */]
  },
  lite: {
    type: APP,
    compare: __WEBPACK_IMPORTED_MODULE_1__app__["a" /* compareAppVersion */]
  },
  ios: {
    type: SYSTEM,
    compare: __WEBPACK_IMPORTED_MODULE_1__app__["c" /* compareSysVersion */]
  },
  android: {
    type: SYSTEM,
    compare: __WEBPACK_IMPORTED_MODULE_1__app__["c" /* compareSysVersion */]
  },
  beatles: {
    type: APP,
    compare: __WEBPACK_IMPORTED_MODULE_1__app__["a" /* compareAppVersion */]
  },
  blord: {
    type: APP,
    compare: __WEBPACK_IMPORTED_MODULE_1__app__["a" /* compareAppVersion */]
  }
};

// let tokenCache = {};
function initIS(DDBridge) {
  DDBridge.is = function (rule) {
    try {
      var groups = tokenize(rule);
      return parse(groups);
    } catch (e) {
      console.error(e.message);
    }
  };
}

/**
 * 词法分析
 * @param rule
 * @example 'passenger'
 * @example 'passenger>=5.0'
 * @example 'passenger>=5.0 and ios>9.3.2'
 * @example 'passenger>=5.0 and ios>9.3.2, driver >=3.0, lite >=1.0'
 * @return Array
 */
function tokenize(rule) {
  // if (tokenCache[rule]) {
  // 	return tokenCache[rule];
  // }
  var soFar = rule;
  // 根据comma分组
  var groups = [];
  var matched = void 0;

  while (soFar) {
    var tokens = void 0;
    var match = commaRE.exec(soFar);
    if (!matched || match) {
      // 删除comma
      if (match) {
        soFar = soFar.slice(match[0].length) || soFar;
      }
      tokens = [];
      groups.push(tokens);
    }

    matched = false;

    var more = true;
    var error = false;
    // 解析每个表达式
    do {
      var expression = {};
      // 拿到identity
      match = identRE.exec(soFar);
      if (match) {
        matched = match.shift();
        expression.identity = matched;
        soFar = soFar.slice(matched.length);
      } else {
        error = ERR_IDENTITY;
        break;
      }
      // 再尝试拿操作符
      match = opRE.exec(soFar);
      if (match) {
        matched = match.shift();
        expression.operator = matched.trim();
        soFar = soFar.slice(matched.length);

        // 如果有操作符,就必须有版本号
        match = versionRE.exec(soFar);
        if (match) {
          matched = match.shift();
          expression.version = matched;
          soFar = soFar.slice(matched.length);
        } else {
          error = ERR_VERSION;
          break;
        }
      }
      tokens.push(expression);
      // 最后拿and
      match = andRE.exec(soFar);
      if (match) {
        matched = match.shift();
        soFar = soFar.slice(matched.length);
        more = true;
      } else {
        more = false;
      }
    } while (more);

    if (error !== false) {
      throw new Error('the rule is error, ' + errMsg[error]);
    }
  }
  // cache
  // tokenCache[rule] = groups;
  return groups;
}

/**
 * 解析词法分析的结果
 * @param group
 * @return Boolean
 */
function parse(groups) {
  var ret = false;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* each */])(groups, function (tokens) {
    var result = true;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* each */])(tokens, function (expression) {
      var identity = expression.identity,
          operator = expression.operator,
          version = expression.version;
      // 白名单

      var ident = identityList[identity];
      if (!ident) {
        throw new Error('unknown identity:' + identity + '!');
      }
      var equal = false;
      var type = ident.type;
      if (type === SYSTEM) {
        equal = __WEBPACK_IMPORTED_MODULE_1__app__["d" /* app */].system === identity;
      } else if (type === APP) {
        if (identity == 'driver') {
          equal = __WEBPACK_IMPORTED_MODULE_1__app__["d" /* app */].env === identity || __WEBPACK_IMPORTED_MODULE_1__app__["d" /* app */].driver;
        } else {
          equal = __WEBPACK_IMPORTED_MODULE_1__app__["d" /* app */].env === identity;
        }
      }
      if (!operator || !equal) {
        result = result && equal;
      } else {
        var compareFn = ident.compare;
        result = result && compareFn(operator, version);
      }
    });
    ret = ret || result;
  });
  return ret;
}

/***/ }),

/***/ "5Z2C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAppVersion;
/* harmony export (immutable) */ __webpack_exports__["b"] = compareVersion;
/* harmony export (immutable) */ __webpack_exports__["c"] = entranceConfigAlias;
/* unused harmony export btnShareConfigAlias */
/* harmony export (immutable) */ __webpack_exports__["d"] = shareConfigAlias;
/* harmony export (immutable) */ __webpack_exports__["e"] = mockOrCall;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env__ = __webpack_require__("8mnA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__method__ = __webpack_require__("1KHg");

/**
 * 存放和bridge功能极为相关的处理方法
 */



/**
 * 获得对象版本的app version
 * @param version
 * @returns {*}
 */
function getAppVersion(version) {
  var target = navigator.userAgent;

  if ((typeof version === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(version)) === 'object') {
    return version;
  }

  if (typeof version === 'string') {
    target = 'didi.passenger/' + version;
  }

  version = (/didi\.passenger\/([\d.]+)/.test(target) ? RegExp.$1 : '0.0.0').split('.');

  switch (version.length) {
    case 1:
      version[1] = version[2] = 0;
      break;
    case 2:
      version[2] = 0;
      break;
  }

  return {
    main: version[0] - 0,
    sub: version[1] - 0,
    mini: version[2] - 0
  };
}

/**
 * 比较app版本大小(eval is harmful)
 * @param version1
 * @param operator
 * @param version2
 * @returns {Boolean}
 */
function compareVersion(version1, operator, version2) {
  var v1 = _parseVersionToInt(version1);
  var v2 = _parseVersionToInt(version2);
  var operators = {
    '>': function _(a, b) {
      return a > b;
    },
    '<': function _(a, b) {
      return a < b;
    },
    '==': function _(a, b) {
      return a === b;
    },
    '===': function _(a, b) {
      return a === b;
    },
    '<=': function _(a, b) {
      return a <= b;
    },
    '>=': function _(a, b) {
      return a >= b;
    }
  };

  return operators[operator](v1, v2);
}

function _parseVersionToInt(version) {
  var num = 0;

  version = getAppVersion(version);
  num += version.main * 10000;
  num += version.sub * 100;
  num += version.mini * 1;
  return num;
}

/**
 * entrance分享配置兼容参数格式
 * @param opts
 */
function entranceConfigAlias(opts) {
  if (opts && opts.buttons) {
    // 兼容两种button分享参数名写法
    var buttons = opts.buttons;
    buttons && buttons.forEach(function (item) {
      if (item) {
        btnShareConfigAlias(item);
      }
    });
  }
}

/**
 * entrance分享配置button兼容参数格式
 * @param data
 */
function btnShareConfigAlias(button) {
  if (button.type) {
    // 统一转为新的type
    var buttonType = button.type;
    if (buttonType === 'page_refresh') {
      button.type = 'refreshPage';
    } else {
      button.type = buttonType.replace(/_(.)/g, function () {
        return arguments[1].toUpperCase();
      });
      // 即使是朋友圈分享大图也肯定至少写icon或img地址
      button.data = button.data || {};
      shareConfigAlias(button.data);
    }
  }
}

/**
 * shareConfig格式兼容
 * @param shareConfig
 */
function shareConfigAlias(shareConfig) {
  if (shareConfig.icon || shareConfig.img) {
    shareConfig.share_title = shareConfig.title;
    shareConfig.share_content = shareConfig.content;
    shareConfig.share_url = shareConfig.url;
    shareConfig.share_icon_url = shareConfig.icon;
    shareConfig.share_img_url = shareConfig.img;
  } else if (shareConfig.share_icon_url || shareConfig.share_img_url) {
    shareConfig.title = shareConfig.share_title;
    shareConfig.content = shareConfig.share_content;
    shareConfig.url = shareConfig.share_url;
    shareConfig.icon = shareConfig.share_icon_url;
    shareConfig.img = shareConfig.share_img_url;
  }
}

/**
 * 模拟bridge在端外的返回值，以请求的形式在业务项目仓库进行模拟，如果是端内正常使用
 */
function mockOrCall(DDbridge, method, opts, cb) {
  opts = opts || {};
  cb = cb || function () {};
  var lowercaseMethod = method.toLowerCase();
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__env__["c" /* inApp */])()) {
    var mockUrl = '/beatles/bridge/api/' + lowercaseMethod;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__method__["c" /* ajax */])({
      url: mockUrl,
      success: function success(response) {
        if (response && response.errno === '0') {
          cb(response.data);
        }
      },
      error: function error() {
        window.console.log('请在项目内mock该请求(在返回结构包括errno为字符串0和data，data里为bridge的结果)：' + mockUrl);
      }
    });
  } else {
    DDbridge.call(method, opts, cb);
  }
}

/***/ }),

/***/ "6MXA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7uB+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initShare;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__("rpWB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_api_alias__ = __webpack_require__("Wf0K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_api_app__ = __webpack_require__("SFol");
/**
 * 原生分享功能的封装
 */







function initShare(DDBridge) {
    DDBridge.setShare = function (param) {
        var buttons = param.buttons;
        // 低版本的，<5.x alias
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__global_api_app__["b" /* isFusionKit */])() && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__global_api_app__["c" /* compareAppVersion */])('<', '5.0.0')) {
            for (var i in buttons) {
                buttons[i].type = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* default */].api[buttons[i].type].alias;
                buttons[i].data && (buttons[i].data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__global_api_alias__["b" /* getOldParamAlias */])(buttons[i].data));
            }
        }
        param.buttons = buttons;
        DDBridge.call('initEntrance', param, function () {});
        DDBridge.call('showEntrance', param, function () {});
    };
}

/***/ }),

/***/ "8Fm4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = each;
/* unused harmony export camelize */
/* unused harmony export noop */
/* harmony export (immutable) */ __webpack_exports__["c"] = logger;
/* harmony export (immutable) */ __webpack_exports__["a"] = invokeInTurn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/**
 * 基础js方法的封装
 * @author huangyiustb
 * @email huangyiustb@didichuxing.com
 */

function each(obj, fn, context) {
  if (!obj || !(typeof fn === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(fn)) === 'function') {
    return;
  }
  context = context || obj;

  if (Array.isArray(obj)) {
    for (var i = 0, l = obj.length; i < l; i++) {
      if (fn.call(context, obj[i], i, obj) === false) {
        return;
      }
    }
  } else if ((typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj)) === 'object') {
    for (var n in obj) {
      if (fn.call(context, obj[n], n, obj) === false) {
        return;
      }
    }
  }
}

var camelizeRE = /_(\w)/g;
function camelize(str) {
  return str.replace(camelizeRE, toUpper);
}

function toUpper(_, c) {
  return c ? c.toUpperCase() : '';
}

function noop() {}

function logger(params) {
  var img = new Image();
  var tmp = Date.now();

  var queryStr = '';

  if (params) {
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        queryStr += key + '=' + params[key] + '&';
      }
    }
  }

  img.src = '//manhattan.activity.xiaojukeji.com/common/serverTime?' + queryStr + 'tmp=' + tmp;
}

var invokeQueue = [];
var invokeInProcess = false;
var interval = 100;

function _invoke() {
  var head = invokeQueue.shift();
  head.fn.apply(head, head.args);
  setTimeout(function () {
    if (invokeQueue.length) {
      _invoke();
    } else {
      invokeInProcess = false;
    }
  }, interval);
}

function invokeInTurn(fn, args) {
  invokeQueue.push({
    fn: fn,
    args: args
  });
  if (!invokeInProcess) {
    invokeInProcess = true;
    _invoke();
  }
}

/***/ }),

/***/ "8mjE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DDBridgeBeatles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_api__ = __webpack_require__("tX21");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("pMqq");
/**
 * 入口js
 *
 */





var DDBridgeBeatles = {};

/* eslint-disable no-undef */
DDBridgeBeatles.Version = '1.0.4';

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__global_api__["a" /* initGlobalAPI */])(DDBridgeBeatles);

DDBridgeBeatles.utils = __WEBPACK_IMPORTED_MODULE_1__util__;



/***/ }),

/***/ "8mnA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = inApp;
/* unused harmony export inBeatles */
/* harmony export (immutable) */ __webpack_exports__["d"] = inBlord;
/* harmony export (immutable) */ __webpack_exports__["b"] = isIos;
/* unused harmony export isAndroid */
/* harmony export (immutable) */ __webpack_exports__["a"] = isFusionKit;
/**
 * 存放关于所处环境判断的方法
 */

/**
 * 判断是在滴滴乘客端内
 * @returns {boolean}
 */
function inApp() {
  var ua = navigator.userAgent;
  return (/didi\.passenger/i.test(ua)
  );
};

/**
 * 判断是在滴滴乘客端顺风车webview内
 * @returns {boolean}
 */
function inBeatles() {
  var ua = navigator.userAgent;
  return (/didi\.passenger.+beatles/i.test(ua)
  );
};

/**
 * 判断是在顺风车独立端内 代号blord
 * @returns {boolean}
 */
function inBlord() {
  var ua = navigator.userAgent;
  return (/didi\.passenger.+beatles\sblord/i.test(ua)
  );
};

/**
 * 判断是ios
 * @returns {boolean}
 */
function isIos() {
  var ua = navigator.userAgent;
  return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

/**
 * 判断是安卓
 * @returns {boolean}
 */
function isAndroid() {
  var ua = navigator.userAgent;
  return ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
}

/**
 * 判断是Fusion容器
 * @returns {boolean}
 */
function isFusionKit() {
  var ua = navigator.userAgent;
  return (/fusionkit/i.test(ua)
  );
}

/***/ }),

/***/ "AEMj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_index__ = __webpack_require__("P/rs");
/**
 * 代驾端 DidiJSBridge 封装
 * 参考：https://git-hz.xiaojukeji.com/kui/native/tree/master
 * @author linkFly(jianglai@didichuxing.com)
 */



function getBridge() {
  return window.WebJsBridge || null;
}

/* harmony default export */ __webpack_exports__["a"] = (function (name, params, callback) {
  var bridge = getBridge();
  if (bridge) {
    var res = bridge[name](params);
    callback(res);
  } else {
    throw Error('android WebJsBridge notfound');
  }
});

/***/ }),

/***/ "DpXv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = bridgeReady;
/* harmony export (immutable) */ __webpack_exports__["a"] = oldMakeBridgeFn;
/* harmony export (immutable) */ __webpack_exports__["b"] = registerHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("pMqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__old_prompt__ = __webpack_require__("PwqI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_api_alias__ = __webpack_require__("Wf0K");
/**
 * DidiJSBridge 封装
 *
 */

var theWindow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["getWindow"])();





var cbs = [];

function init() {
    var bridge = theWindow.DidiJSBridge;
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["isUndefined"])(bridge)) {
        document.addEventListener('DidiJSBridgeReady', onBridgeReady, false);
    } else {
        bridge.init && bridge.init();
    }
}

function onBridgeReady() {
    var bridge = theWindow.DidiJSBridge;
    bridge.init && bridge.init();

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["each"])(cbs, function (cb) {
        cb(bridge);
    });
}

init();

function bridgeReady(callback) {
    var bridge = theWindow.DidiJSBridge;
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["isUndefined"])(bridge)) {
        cbs.push(callback);
    } else {
        // 注册回调事件
        callback(bridge);
    }
}

function oldMakeBridgeFn(name, conf, allConf) {
    return function () {
        var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_0__util__["noop"];

        if (arguments.length === 1 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["isFn"])(param)) {
            callback = param;
            param = '';
        }

        // 低版本bridge alias param alias处理
        var nameParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__global_api_alias__["a" /* alias */])(name, param, conf, allConf);

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__old_prompt__["a" /* supportPrompt */])()) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__old_prompt__["b" /* promptSend */])(nameParams.name, nameParams.param, callback);
        } else {
            bridgeReady(function (bridge) {
                bridge.callHandler(nameParams.name, nameParams.param, function (data) {
                    // 兼容data是字符串的情况
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["isStr"])(data)) {
                        data = JSON.parse(data);
                    }
                    callback(null, data);
                });
            });
        }
    };
};

function registerHandler(fn, callback) {
    bridgeReady(function (bridge) {
        bridge.registerHandler(fn, callback);
    });
};

/***/ }),

/***/ "E0e7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return passengerConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return driverConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return daijiaConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return financeConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("P/rs");

/**
 * 配置文件
 * @author xuxiaoyan
 */



var passengerConfig = {
  /**
   * 初始化右上角更多按钮
   */
  initEntrance: {
    fn: 'init_entrance'
  },
  /**
   * 唤起更多按钮
   */
  invokeEntrance: {
    fn: 'invoke_entrance'
  },
  /**
   * 展示更多按钮
   */
  showEntrance: {
    fn: 'show_entrance'
  },
  /**
   * 隐藏更多按钮
   */
  hideEntrance: {
    fn: 'hide_entrance'
  },
  /**
   * 分享到微信朋友圈
   */
  shareWeixinTimeline: {
    fn: 'share_weixin_timeline'
  },
  /**
   * 分享到微信
   */
  shareWeixinAppmsg: {
    fn: 'share_weixin_appmsg'
  },
  /**
   * 分享到支付宝朋友圈
   */
  shareAlipayLife: {
    fn: 'share_alipay_life'
  },
  /**
   * 分享给支付宝好友
   */
  shareAlipayFriend: {
    fn: 'share_alipay_friend'
  },
  /**
   * 分享到QQ空间
   */
  shareQzone: {
    fn: 'share_qzone'
  },
  /**
   * 分享到QQ
   */
  shareQqAppmsg: {
    fn: 'share_qq_appmsg'
  },
  /**
   * 分享到新浪微博
   */
  shareSinaWeibo: {
    fn: 'share_sina_weibo'
  },
  /**
   * 获取用户信息
   */
  getUserInfo: {
    fn: 'getUserInfo'
  },
  /**
   * 获取系统信息
   */
  getSystemInfo: {
    fn: 'getSystemInfo'
  },
  /**
   * 获取地理位置信息
   */
  getLocationInfo: {
    fn: 'getLocationInfo'
  },
  /**
   * 获取apollo接口
   */
  apolloGetToggle: {
    fn: 'apolloGetToggle'
  },
  /**
   * 刷新页面
   */
  refreshPage: {
    fn: 'page_refresh'
  },
  /**
   * 关闭页面
   */
  closePage: {
    fn: 'page_close'
  },
  /**
   * 打开页面
   */
  openPage: {
    fn: 'openNativeWebPage'
  },
  // /**
  //  * 微信支付
  //  */
  // payByWX: {
  // 	fn: 'payByWX'
  // },
  // /**
  //  * 支付宝支付
  //  */
  // payByAli: {
  // 	fn: 'payByAli'
  // },
  /**
   * 请求登录
   */
  requestLogin: {
    fn: 'callNativeLoginWithCallback'
  },
  /**
   * 设置title
   */
  setTitle: {
    fn: 'updateNaviTitle'
  }
  // /**
  //  * 获得联系人信息
  //  */
  // getContacts: {
  // 	fn: 'getContacts'
  // }
};

var driverConfig = {
  weixinAppmsg: {
    fn: 'weixinAppmsg',
    support: '2.4.4',
    prepare: function prepare(name, config, fn) {
      var conf = {
        url: config.url || config.share_url,
        icon: config.icon || config.icon_url || config.share_icon_url || config.imageUrl,
        title: config.title || config.share_title,
        desc: config.desc || config.content || config.share_content || config.descript
      },
          cfg;

      if (__WEBPACK_IMPORTED_MODULE_1__util__["c" /* isIOS */]) {
        cfg = {
          share_url: conf.url,
          share_icon_url: conf.icon,
          share_title: conf.title,
          share_content: conf.desc
        };
        return ['share_weixin_appmsg', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(cfg), function () {}];
      } else if (__WEBPACK_IMPORTED_MODULE_1__util__["b" /* isAndroid */]) {
        cfg = {
          url: conf.url,
          imageUrl: conf.icon,
          title: conf.title,
          descript: conf.desc,
          isFriendCircle: false
        };
        return ['callWXShare', cfg, function () {}];
      }
    }
  },
  weixinTimeline: {
    fn: 'weixinTimeline',
    support: '2.4.4',
    prepare: function prepare(name, config, fn) {
      var conf = {
        url: config.url || config.share_url,
        icon: config.icon || config.icon_url || config.share_icon_url || config.imageUrl,
        title: config.title || config.share_title,
        desc: config.desc || config.content || config.share_content || config.descript
      },
          cfg;

      if (__WEBPACK_IMPORTED_MODULE_1__util__["c" /* isIOS */]) {
        cfg = {
          share_url: conf.url,
          share_icon_url: conf.icon,
          share_title: conf.title,
          share_content: conf.desc
        };
        return ['share_weixin_timeline', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(cfg), function () {}];
      } else if (__WEBPACK_IMPORTED_MODULE_1__util__["b" /* isAndroid */]) {
        cfg = {
          url: conf.url,
          imageUrl: conf.icon,
          title: conf.title,
          descript: conf.desc,
          isFriendCircle: true
        };
        return ['callWXShare', cfg, function () {}];
      }
    }
  },
  shareSms: {
    fn: 'share_sms',
    support: '2.4.4'
  },
  initEntrance: {
    fn: 'init_entrance',
    support: '2.4.4'
  },
  hideEntrance: {
    fn: 'hide_entrance',
    support: [{ type: 'android', version: '2.4.4' }]
  },
  showEntrance: {
    fn: 'show_entrance',
    support: [{ type: 'android', version: '2.4.4' }]
  },
  invokeEntrance: {
    fn: 'share_slide_up',
    support: '2.4.4'
  },
  pageClose: {
    fn: 'page_close',
    support: '2.4.5'
  },
  getContact: {
    fn: 'readPhoneContact',
    support: [{ type: 'android', version: '2.4.4' }]
  },
  withdrawCash: {
    fn: 'withdraw_cash',
    support: '2.4.4'
  },
  driverOut: {
    fn: 'driverOut',
    support: '2.4.5'
  },
  toMainPage: {
    fn: 'toMainPage',
    support: '2.4.4'
  },
  resizeImage: {
    fn: 'resizeImage',
    support: [{ type: 'android', version: '2.4.4' }]
  },
  photograph: {
    fn: 'photograph',
    support: '2.4.4'
  },
  orderDetailInfo: {
    fn: 'orderDetailInfo',
    support: '2.4.4'
  },
  orderReassignState: {
    fn: 'orderReassignState',
    support: [{ type: 'ios', version: '2.4.4' }]
  },
  checkOrderDetail: {
    fn: 'checkOrderDetail',
    support: '2.4.4'
  },
  getUserInfo: {
    fn: 'getUserInfo',
    support: '2.4.5',
    prepare: function prepare(name, fn) {
      return ['getUserInfo', {}, fn];
    }
  },
  getSystemInfo: {
    fn: 'getSystemInfo',
    support: '3.1.6',
    prepare: function prepare(name, fn) {
      return ['getSystemInfo', {}, fn];
    }
  },
  getLocationInfo: {
    fn: 'getLocationInfo',
    support: '2.4.4',
    prepare: function prepare(name, fn) {
      return ['getLocationInfo', {}, fn];
    }
  },
  launchNav: {
    fn: 'launchNav',
    support: '2.4.4'
  },
  launchScan: {
    fn: 'launchScan',
    support: '5.0.22'
  },
  openPage: {
    fn: 'openPage'
  },
  addCornerButton: {
    fn: 'addCornerButton',
    support: '2.5.2',
    prepare: function prepare(name, params, fn) {
      //重置回调名，避免覆盖的可能
      var jsCall = "" + params.jsCallback + new Date().getTime();
      params.jsCallback = jsCall;
      if (__WEBPACK_IMPORTED_MODULE_1__util__["c" /* isIOS */]) {
        window.DidiJSBridge && DidiJSBridge.registerHandler(jsCall, fn);
      } else if (__WEBPACK_IMPORTED_MODULE_1__util__["b" /* isAndroid */]) {
        window[jsCall] = fn;
      }
      return ['addCornerButton', params, function () {}];
    }
  },
  resetBack: {
    fn: 'resetBack',
    support: '2.6.0'
  }
};

var daijiaConfig = {
  jumpUrl: {
    fn: 'jumpUrl'
  }
};

var financeConfig = {
  /**
   * 设置webview的标题
   */
  setTitle: {
    fn: 'setTitle'
  },
  /**
   * 打开新页面
   */
  openPage: {
    fn: 'setTitle'
  },
  /**
   * 关闭页面
   */
  closePage: {
    fn: 'closePage'
  },
  /**
   * 刷新页面
   */
  refreshPage: {
    fn: 'refreshPage'
  },
  /**
   * 唤起登陆
   */
  requestLogin: {
    fn: 'requestLogin'
  },
  /**
   * 获取系统信息
   */
  getSystemInfo: {
    fn: 'getSystemInfo'
  },
  /**
   * 获取用户信息
   */
  getUserInfo: {
    fn: 'getUserInfo'
  },
  /**
   * 获取地理位置信息
   */
  getLocationInfo: {
    fn: 'getLocationInfo'
  },
  /**
   * 人脸识别
   */
  faceRecognize: {
    fn: 'faceRecognize'
  },
  /**
   * 支付
   */
  openUniPay: {
    fn: 'openUniPay'
  }
};

/***/ }),

/***/ "EVtu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__("y0Wx");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__lang__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__link__ = __webpack_require__("uhI5");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__env__ = __webpack_require__("zIJ9");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__env__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__env__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__env__["c"]; });




/***/ }),

/***/ "EiWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("P/rs");
/**
 * 代驾端 DidiJSBridge 封装
 * 参考：https://git-hz.xiaojukeji.com/kui/native/tree/master
 * @author linkFly(jianglai@didichuxing.com)
 */



/*
  工作原理：
    访问代驾的私协，代驾会注入 window.WebViewJavascriptBridge， 这就是代驾 bridge
    然后会执行 window.WVJBCallbacks（这是一个回调函数 array）
    然后调用 bridge.callHandler 就可以调用对应方法了
    代驾的回调函数直接就返回了结果，和乘客端不一样（乘客端返回结果是 { errorno, errmsg, result })
*/
var schema = 'wvjbscheme://__BRIDGE_LOADED__',
    loadedFrame = false;

function createFrame() {
  var src = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : schema;

  var frame = document.createElement('IFRAME');
  frame.style.display = 'none';
  frame.src = src;
  document.body.appendChild(frame);
  loadedFrame = true;
  setTimeout(function () {
    document.body.removeChild(frame);
  }, 100);
}

if (!window.WVJBCallbacks) {
  window.WVJBCallbacks = [];
}

function getBridge() {
  return window.WebViewJavascriptBridge || null;
}

/* harmony default export */ __webpack_exports__["a"] = (function (name, params, callback) {
  var bridge = getBridge();
  var cb = function cb(_bridge) {
    _bridge.callHandler(name, params, callback);
  };
  if (bridge) {
    cb(bridge);
  } else {
    window.WVJBCallbacks.push(cb);
    // 如果还没有访问过私协，则立即访问
    if (!loadedFrame) {
      createFrame();
    }
  }
});

/***/ }),

/***/ "FrXa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FusionClass; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__("OvRC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__("EVtu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_config__ = __webpack_require__("sazR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__global__ = __webpack_require__("SJHH");





var theWindow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["a" /* getWindow */])();





var FusionClass = function () {
    function FusionClass(version) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FusionClass);

        this.version = version;
        // this.getModuleMethods();
    }
    /**
     * JS 调用 Native
     *
     * @param      {string}  module  模块名
     * @param      {string}  method  方法名
     */


    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(FusionClass, [{
        key: 'invokeNative',
        value: function invokeNative(module, method) {
            return function () {
                var args = [];
                var globalInstance = __WEBPACK_IMPORTED_MODULE_6__global__["a" /* Global */].getInstance();
                var cbName = globalInstance.callbackId.toString();

                for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
                    params[_key] = arguments[_key];
                }

                for (var i in params) {
                    // 防止被不法分子坑，遍历出原型上的东西
                    if (params.hasOwnProperty(i)) {
                        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["b" /* isFunction */])(params[i])) {
                            globalInstance.callbacks[cbName] = params[i];
                            args.push(cbName);
                            globalInstance.callbackId++;
                        } else {
                            args.push(params[i]);
                        }
                    }
                }
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["c" /* bridgeCall */])('invokeNative', module, method, args);
            };
        }

        /**
         * Native 回调 JS
         *
         * @param      {number}  callbackID  回调函数 ID
         * @param      {array}   arg         回调参数
         */

    }, {
        key: 'callbackJS',
        value: function callbackJS(cbName, args) {
            var globalInstance = __WEBPACK_IMPORTED_MODULE_6__global__["a" /* Global */].getInstance();
            var callback = globalInstance.callbacks[cbName];
            if (callback && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["b" /* isFunction */])(callback)) {
                callback.apply(null, args);
            }
            globalInstance.callbacks[cbName] = function () {};
        }

        /**
         * Native 调用 JS 函数接口
         *
         * @param      {string}  module     The module
         * @param      {string}  method     The method name
         * @param      {array}   args       The arguments
         */

    }, {
        key: 'invokeJSMethod',
        value: function invokeJSMethod(module, method, args) {
            var _this = this;

            var newArgs = [];
            var callbackIdRegExp = /^__\${(\d)+}__$/;
            for (var i in args) {
                if (callbackIdRegExp.exec(args[i])) {
                    (function () {
                        var callbackId = callbackIdRegExp.exec(args[i])[1];
                        var self = _this;
                        var func = function func() {
                            for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                                params[_key2] = arguments[_key2];
                            }

                            self.callbackNative(callbackId, params);
                        };
                        newArgs.push(func);
                    })();
                } else {
                    newArgs.push(args[i]);
                }
            }
            if (__WEBPACK_IMPORTED_MODULE_5__config_config__["a" /* CONFIG */].SYS_MODULE.indexOf(module) !== -1) {
                this[method].apply(this, newArgs);
                return;
            }
            var object = this.loadModule(module);
            object[method].apply(null, newArgs);
        }

        /**
         * Native 回调 JS
         *
         * @param      {number}  cbName     回调函数 ID
         * @param      {array}   args       回调参数
         */

    }, {
        key: 'callbackNative',
        value: function callbackNative(cbName, args) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["c" /* bridgeCall */])('callbackNative', null, cbName, args);
        }

        /**
         * 注册（多个）模块
         *
         * @param      {array}  modules    模块对象列表
         */

    }, {
        key: 'registerModules',
        value: function registerModules(modules) {
            for (var i in modules) {
                if (__WEBPACK_IMPORTED_MODULE_5__config_config__["a" /* CONFIG */].SYS_MODULE.indexOf(modules[i].module) >= 0) {
                    for (var j in modules[i].methods) {
                        if (!this[modules[i].methods[j]]) {
                            this[modules[i].methods[j]] = this.invokeNative(modules[i].module, modules[i].methods[j]);
                        }
                    }
                } else {
                    this.registerModule(modules[i].module);
                    for (var _j in modules[i].methods) {
                        var object = this.loadModule(modules[i].module);
                        object.registerFn(modules[i].methods[_j]);
                    }
                }
            }
        }
    }, {
        key: 'registerModule',


        /**
         * 注册单个模块
         *
         * @param      {object}  modules    模块对象
         */
        value: function registerModule(module) {
            var globalInstance = __WEBPACK_IMPORTED_MODULE_6__global__["a" /* Global */].getInstance();
            var object = globalInstance.modules[module];
            if (!object) {
                var self = this;
                globalInstance.modules[module] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()({
                    registerFn: function registerFn(method) {
                        this[method] = self.invokeNative(module, method);
                    }
                });
            }
        }

        /**
         * 加载模块
         *
         * @param      {string}  module     模块名称
         */

    }, {
        key: 'loadModule',
        value: function loadModule(module) {
            var globalInstance = __WEBPACK_IMPORTED_MODULE_6__global__["a" /* Global */].getInstance();
            var object = globalInstance.modules[module];
            if (object) {
                return object;
            }
            this.registerModule(module);

            return globalInstance.modules[module];
        }
        /**
         * 获取客户端内置模块
         *
         */

    }, {
        key: 'fetchJSModules',
        value: function fetchJSModules() {
            if (__WEBPACK_IMPORTED_MODULE_4__util__["d" /* isAndroid */]) {
                if (__WEBPACK_IMPORTED_MODULE_4__util__["e" /* withFusion */]) {
                    var message = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
                        fusion: 'loadJSModules'
                    });
                    var results = theWindow.prompt(message);
                    try {
                        results = JSON.parse(results);
                        this.registerModules(results);
                    } catch (e) {}
                }
            } else {
                var self = this;
                if (theWindow.loadJSModules) {
                    theWindow.loadJSModules(function (modules) {
                        self.registerModules(modules);
                    });
                }
            }
        }
    }]);

    return FusionClass;
}();;

/***/ }),

/***/ "KJQd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createFrame;
/* harmony export (immutable) */ __webpack_exports__["b"] = getWindow;
function createFrame(src) {
  var frame = document.createElement('IFRAME');
  frame.style.display = 'none';
  frame.src = src;
  document.body.appendChild(frame);
  return frame;
};

function getWindow() {
  var theWindow = window;
  var testCanGetTop = false;

  // 如果是在iframe内
  if (window.parent !== window) {
    // 通过try尝试是否可以取到top的属性，否则就是取不到 hack...
    try {
      testCanGetTop = window.top.document;
      testCanGetTop = true;
    } catch (e) {
      testCanGetTop = false;
    }
    if (testCanGetTop) {
      theWindow = window.top;
    }
  }
  return theWindow;
};

/***/ }),

/***/ "KPKY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_bridge__ = __webpack_require__("FrXa");


// if (window.Fusion) {
//   throw new Error('Fusion has existed! You can ignore this error.');
// }

/* eslint-disable no-undef */
var Fusion = new __WEBPACK_IMPORTED_MODULE_0__core_bridge__["a" /* FusionClass */]('1.0.6');
Fusion.fetchJSModules();

/* harmony default export */ __webpack_exports__["a"] = (Fusion);
// module.exports = Fusion;

/***/ }),

/***/ "L5nL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LGhb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = callIOS;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("P/rs");

/**
 * prompt 封装
 * @author huangyiustb
 * @modify xuxiaoyan
 * http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=75128588
 */



var schema = 'didibridge://BRIDGE_CALL?callback=',
    msgFrame = null;

var __uid = 0;

function createFrame(src) {
  var frame = document.createElement('IFRAME');
  frame.id = 'mfe-webview-util-iframe';
  frame.style.display = 'none';
  frame.src = src;
  document.body.appendChild(frame);
  return frame;
}

function callIOS(fn, param, callback) {
  var id = __uid++;
  var callbackName = '__bridgeCall__' + id;

  var callData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    cmd: fn,
    id: id,
    params: param,
    callback: callbackName
  });

  var callDataName = '__getCallData__' + id;
  window[callDataName] = function () {
    delete window[callDataName];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* logger */])({
      pos: 'IOS_RETURN_JSON',
      callDataName: callDataName
    });
    return callData;
  };

  window[callbackName] = function (retData) {
    if (typeof retData === 'string') {
      try {
        retData = JSON.parse(retData);
      } catch (e) {
        retData = {};
      }
    }

    // compatibility for Fusion
    var errno = retData.errno !== undefined ? retData.errno : retData.errorno;
    var errmsg = retData.errmsg !== undefined ? retData.errmsg : retData.errormsg;

    var err = +errno !== __WEBPACK_IMPORTED_MODULE_1__util__["i" /* ERR_OK */] ? { errno: errno, errmsg: errmsg } : null;

    delete window[callbackName];

    // node style
    callback(err, retData.result || retData);
  };

  // do send
  var src = schema + callDataName;
  send(src);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* logger */])({
    pos: 'IOS_SEND_MSG',
    src: src
  });
}

function send(src) {

  if (!msgFrame) {
    msgFrame = createFrame(src);
  } else {
    msgFrame.src = src;
  }
}

/***/ }),

/***/ "N7kH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = callHandler;
/* harmony export (immutable) */ __webpack_exports__["d"] = beatlesCommunicate;
/* harmony export (immutable) */ __webpack_exports__["b"] = callNative;
/* harmony export (immutable) */ __webpack_exports__["c"] = listenNative;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_old_bridge__ = __webpack_require__("DpXv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_old_prompt__ = __webpack_require__("PwqI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__("+IIN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util__ = __webpack_require__("pMqq");









/**
 * _beatlesCommunicate 顺风车扩展协议实现之客户端调用前端
 * @param data
 * @param fn
 * @private
 */
function _beatlesCommunicate(data, fn) {
  if (data && data['header']) {
    var header = data['header'];
    var eventKey = header['event_key'];
    if (eventKey) {
      var event = document.createEvent('Event');
      event.initEvent(eventKey);
      event.data = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
      document.dispatchEvent(event);
    }
  }
  fn && fn('{"communitcate": "ok"}');
};

/**
 * 4.x和5.x 注册_beatlesCommunicate方法
 */
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_old_bridge__["c" /* bridgeReady */])(function (bridge) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["getWindow"])().DidiBeatlesJSBridge = bridge;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util__["f" /* isIos */])() && bridge.init && bridge.init();
  bridge._beatlesCommunicate = _beatlesCommunicate;
  // ios 使用
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util__["f" /* isIos */])()) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_old_bridge__["b" /* registerHandler */])('_beatlesCommunicate', bridge._beatlesCommunicate);
  }
});

/**
 * Fusion 新容器 注册_beatlesCommunicate方法
 */
registerFusionPassiveBC();

function registerFusionPassiveBC() {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["getWindow"])().Fusion) {
    var Beatles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["getWindow"])().Fusion.loadModule('Beatles');
    Beatles._beatlesCommunicate = _beatlesCommunicate;
  }
}

/**
 * 封装调用callHandler方法
 * @param name
 * @param param
 * @param callback
 */
function callHandler(name, param, callback) {
  callback = callback || __WEBPACK_IMPORTED_MODULE_4__util__["noop"];
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_old_prompt__["a" /* supportPrompt */])()) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_old_prompt__["b" /* promptSend */])(name, param, callback);
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_old_bridge__["c" /* bridgeReady */])(function (bridge) {
      bridge.callHandler(name, param, function (data) {
        // 兼容data是字符串的情况
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util__["isStr"])(data)) {
          data = JSON.parse(data);
        }
        callback.length === 1 ? callback(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)) : callback(null, data);
      });
    });
  }
}

/**
 * 封装beatlesCommunicate方法 走4.x协议
 * @param params
 */
function beatlesCommunicate(params) {
  var eventKey = params.header.event_key;
  // ios initPushType要早于showEntrance调用，但是安卓要晚于showEntrance。历史原因。。。
  if (eventKey === 'initPushType') {
    var timeDelay = 360;
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util__["f" /* isIos */])()) {
      timeDelay = 260;
    }
    setTimeout(function () {
      callHandler('beatlesCommunicate', params);
    }, timeDelay);
  } else {
    callHandler('beatlesCommunicate', params);
  }
}

/**
 * 进一步封装beatlesCommunicate协议使用方式
 * @param eventKey
 * @param bodyData
 * @param cb
 * @param callbackOnce
 */
function callNative(eventKey, bodyData, cb, callbackOnce) {
  // 变量
  eventKey = eventKey || '';
  bodyData = bodyData || {};
  bodyData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* extendSimple */])({}, bodyData);
  // 监听客户端调用_beatlesCommunicate，定义 "回调eventKey"
  if (cb) {
    // "回调eventKey" 数附加到bodyData中
    var callbackEventkey = 'event_key_' + Math.abs(~~(Math.random() * 1E10));
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* extendSimple */])(bodyData, {
      callback: callbackEventkey
    });
    // alert(JSON.stringify(callbackEventkey));
    // 监听客户端回调事件
    listenNative(callbackEventkey, function (resObj) {
      cb(resObj);
    }, callbackOnce);
  }
  // 协议调用
  beatlesCommunicate({
    header: {
      event_id: 7,
      event_key: eventKey,
      event_type: 1,
      page_url: window.location.href
    },
    body: bodyData
  });
}

/**
 * 监听顺风车客户端调用js方法
 * @param eventKey
 * @param cb
 * @param callbackOnce
 */
function listenNative(eventKey, cb, callbackOnce) {
  // 监听客户端调用_beatlesCommunicate事件
  var listener = function listener(e) {
    // callback
    var callbackBodyData;
    if (e && e.data && e.data.body) {
      try {
        callbackBodyData = JSON.parse(e.data.body);
      } catch (ex) {
        callbackBodyData = e.data.body;
      }
    }
    cb(callbackBodyData);
    // removeEventListener
    if (callbackOnce) {
      document.removeEventListener(eventKey, listener, false);
    }
  };
  document.addEventListener(eventKey, listener, false);
}

/***/ }),

/***/ "P/rs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__("0y8L");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__env__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__env__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__env__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__env__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__env__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errno__ = __webpack_require__("R0/4");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__errno__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lang__ = __webpack_require__("8Fm4");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__lang__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__lang__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__lang__["c"]; });




/***/ }),

/***/ "PwqI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = promptSend;
/* harmony export (immutable) */ __webpack_exports__["a"] = supportPrompt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("pMqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_api_app__ = __webpack_require__("SFol");

/**
 * prompt 封装, Andrid大于4.2.0版本均可以用
 *
 */





var theWindow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["getWindow"])();
var __uid = 0;
var callbacks = {};

function initPrompt() {
  // 因为安卓源码里写死了,这里的hack我很不喜欢
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["isUndefined"])(theWindow.didi) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["isUndefined"])(theWindow.didi.bridge)) {
    theWindow.didi.bridge._callback = promptCallback;
  } else {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["isUndefined"])(theWindow.didi)) {
      theWindow.didi = {};
    }
    theWindow.didi.bridge = {};
    theWindow.didi.bridge._callback = promptCallback;
  }
}

function promptCallback(obj) {
  // 兼容obj是字符串的情况
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["isStr"])(obj)) {
    obj = JSON.parse(obj);
  }
  var _obj = obj,
      id = _obj.id,
      result = _obj.result;

  var callback = callbacks[id];
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["isFn"])(callback)) {
    callback.length === 1 ? callback(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result)) : callback(null, result);
  }
}

initPrompt();

function promptSend(fn, param, callback) {
  var id = __uid++;
  var message = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    cmd: fn,
    id: id,
    params: param
  });
  callbacks[id] = callback;
  theWindow.prompt(message);
};

function supportPrompt() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__global_api_app__["f" /* isAndroid */])() && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__global_api_app__["c" /* compareAppVersion */])('>', '4.2.0');
};

/***/ }),

/***/ "QVuP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");


// import Home from '../components/home.vue'
// import Test from '../components/test.vue'

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

// const Test = r => require.ensure([], () => r(require('./../components/test.vue')));
var Home = function Home(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__("ft6y"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var handInput = function handInput(r) {
  return __webpack_require__.e/* require.ensure */(8).then((function () {
    return r(__webpack_require__("gJl5"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var charge = function charge(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__("eCDV"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var chargingProcess = function chargingProcess(r) {
  return __webpack_require__.e/* require.ensure */(5).then((function () {
    return r(__webpack_require__("6pDV"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var payBill = function payBill(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__("ZDKh"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var personalCenterCollection = function personalCenterCollection(r) {
  return __webpack_require__.e/* require.ensure */(14).then((function () {
    return r(__webpack_require__("OOAP"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var personalCenter = function personalCenter(r) {
  return __webpack_require__.e/* require.ensure */(11).then((function () {
    return r(__webpack_require__("xtGe"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var personalCenterOrder = function personalCenterOrder(r) {
  return __webpack_require__.e/* require.ensure */(9).then((function () {
    return r(__webpack_require__("qoP3"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var personalCenterHelp = function personalCenterHelp(r) {
  return __webpack_require__.e/* require.ensure */(15).then((function () {
    return r(__webpack_require__("7cRq"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var orderDetail = function orderDetail(r) {
  return __webpack_require__.e/* require.ensure */(10).then((function () {
    return r(__webpack_require__("4jTB"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var coupon = function coupon(r) {
  return __webpack_require__.e/* require.ensure */(20).then((function () {
    return r(__webpack_require__("KAmz"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var personalAchieve = function personalAchieve(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__("ovv1"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var personalAchieveRule = function personalAchieveRule(r) {
  return __webpack_require__.e/* require.ensure */(17).then((function () {
    return r(__webpack_require__("IvY9"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var tempActive = function tempActive(r) {
  return __webpack_require__.e/* require.ensure */(6).then((function () {
    return r(__webpack_require__("1CO7"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var personalBalance = function personalBalance(r) {
  return __webpack_require__.e/* require.ensure */(16).then((function () {
    return r(__webpack_require__("P3Rr"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var personalQuestion = function personalQuestion(r) {
  return __webpack_require__.e/* require.ensure */(19).then((function () {
    return r(__webpack_require__("FZ1h"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var chargeActiveIframe = function chargeActiveIframe(r) {
  return __webpack_require__.e/* require.ensure */(21).then((function () {
    return r(__webpack_require__("asW7"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var recommend = function recommend(r) {
  return __webpack_require__.e/* require.ensure */(12).then((function () {
    return r(__webpack_require__("Xzhc"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var recommendDetail = function recommendDetail(r) {
  return __webpack_require__.e/* require.ensure */(13).then((function () {
    return r(__webpack_require__("wuPc"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var card = function card(r) {
  return __webpack_require__.e/* require.ensure */(7).then((function () {
    return r(__webpack_require__("++Nh"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var userProtocol = function userProtocol(r) {
  return __webpack_require__.e/* require.ensure */(18).then((function () {
    return r(__webpack_require__("BtOC"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var noticeCenter = function noticeCenter(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__("CsEA"));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  // base: __dirname,
  routes: [{
    path: '/epower/epower.html',
    component: Home,
    meta: {
      title: '小桔充电'
    }
  }, {
    path: '/epower/handInput',
    name: 'handInput',
    component: handInput
  }, {
    path: '/epower/charge',
    component: charge,
    meta: {
      title: '费用确认'
    }
  }, {
    path: '/epower/chargingProcess',
    component: chargingProcess,
    meta: {
      title: '小桔充电'
    }
  }, {
    path: '/epower/payBill',
    component: payBill,
    meta: {
      title: '账单确认'
    }
  }, {
    path: '/epower/personalCenterCollection',
    component: personalCenterCollection,
    meta: {
      title: '我的收藏'
    }
  }, {
    path: '/epower/personalCenter',
    component: personalCenter,
    meta: {
      title: '个人中心'
    }
  }, {
    path: '/epower/personalCenterOrder',
    component: personalCenterOrder,
    meta: {
      title: '我的订单'
    }
  }, {
    path: '/epower/personalCenterHelp',
    component: personalCenterHelp,
    meta: {
      title: '帮助'
    }
  }, {
    path: '/epower/orderDetail',
    component: orderDetail,
    meta: {
      title: '订单详情'
    }
  }, {
    path: '/epower/coupon',
    component: coupon,
    meta: {
      title: '我的优惠券'
    }
  }, {
    path: '/epower/achieve',
    component: personalAchieve,
    meta: {
      title: '充电成就'
    }
  }, {
    path: '/epower/achieveRule',
    component: personalAchieveRule,
    meta: {
      title: '充电成就'
    }
  }, {
    path: '/epower/tempActive',
    component: tempActive,
    meta: {
      title: '喜迎新年 一元充电'
    }
  }, {
    path: '/epower/personBalance',
    component: personalBalance,
    meta: {
      title: '充电余额'
    }
  }, {
    path: '/epower/personalQuestion',
    component: personalQuestion,
    meta: {
      title: '常见问题'
    }
  }, {
    path: '/epower/chargeActiveIframe/:city',
    component: chargeActiveIframe,
    meta: {
      title: '小桔充电'
    }
  }, {
    path: '/epower/recommend',
    component: recommend,
    meta: {
      title: '推荐有奖'
    }
  }, {
    path: '/epower/recommendDetail',
    component: recommendDetail,
    meta: {
      title: '奖励详情'
    }
  }, {
    path: '/epower/card',
    component: card,
    meta: {
      title: '小桔充电，电车充电平台首选'
    }
  }, {
    path: '/epower/userProtocol',
    component: userProtocol,
    meta: {
      title: '小桔充电，电车充电平台首选'
    }
  }, {
    path: '/epower/noticeCenter',
    component: noticeCenter,
    meta: {
      title: '消息中心'
    }
  }]
}));

/***/ }),

/***/ "R0/4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERR_OK; });
/* unused harmony export ERR_FUNCTION_NOT_EXIST */
/* unused harmony export ERR_CALLBACK_ERROR */
/* unused harmony export ERR_ENV_ERROR */
/**
 * 常见的错误码
 * @author huangyiustb
 * @email huangyiustb@didichuxing.com
 */

var ERR_OK = 0;

var ERR_FUNCTION_NOT_EXIST = 1001;

var ERR_CALLBACK_ERROR = 1002;

var ERR_ENV_ERROR = 2001;

/***/ }),

/***/ "SFol":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return app; });
/* harmony export (immutable) */ __webpack_exports__["a"] = initApp;
/* unused harmony export isIos */
/* harmony export (immutable) */ __webpack_exports__["f"] = isAndroid;
/* harmony export (immutable) */ __webpack_exports__["b"] = isFusionKit;
/* harmony export (immutable) */ __webpack_exports__["d"] = inApp;
/* harmony export (immutable) */ __webpack_exports__["c"] = compareAppVersion;
/* harmony export (immutable) */ __webpack_exports__["g"] = compareSysVersion;
/* unused harmony export compare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("pMqq");
/**
 * 环境判断
 */


var theWindow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["getWindow"])();

var UA = theWindow.navigator.userAgent.toLowerCase();

// 客户端
var regs = {
  'android': /android/i,
  'ios': /iphone/i,

  'weixin': /micromessenger/i,
  'mqq': /QQ\//i,
  'alipay': /aliapp/i,
  'ding': /dingtalk/i,
  'passenger': /didi.passenger/i,
  'lite': /didi.lite/i,
  'sdk': /didi.sdk/i,
  'driverAndroid': /didigsui/i,
  'driverIOS': /ddudriver/i,
  'chrome': /chrome\//i,
  'fusion': /fusionkit/i,
  'guarana': /guarana/i

};

// 版本号
var versionRegs = {
  'passenger': /didi.passenger.*?\/([\d\.]+)/i,
  'lite': /didi.lite\/(.+)$/i,
  'driverAndroid': /didigsui.*_(.+)_\d+_*/i,
  'driverIOS': /ddudriver.*\d_(\d+\.\d+\.\d+)_*/i,
  'android': /android ([\d\.]+)/i,
  'ios': /iphone os ([\d_]+)/i,
  'fusion': /fusionkit\/([\d\.]+)/i
};

var UNKNOWN = 'others';

var app = {};

function initApp(DDBridge) {
  var ret = {};
  var version = {};

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["each"])(regs, function (value, key) {
    ret[key] = value.test(UA);
  });
  if (ret.lite) {
    ret.lite = true;
  }
  if (ret.driverAndroid || ret.driverIOS) {
    ret.driver = true;
  };

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["each"])(versionRegs, function (value, key) {
    if (ret[key]) {
      var match = value.exec(UA);

      var res = 'unkown';
      if (match) {
        res = match[1];
      } else {}
      version[key] = res;
    }
  });
  version.passenger = version.passenger || version.lite;
  version.driver = version.driverAndroid || version.driverIOS;

  DDBridge.ua = ret;
  DDBridge.app = app = {
    env: ret.lite ? 'lite' : ret.passenger ? 'passenger' : ret.driver ? 'driver' : UNKNOWN,
    version: version.passenger || version.driver,
    system: ret.ios ? 'ios' : ret.android ? 'android' : UNKNOWN,
    sysVersion: version.ios || version.android,
    fusionKit: ret.fusion,
    guarana: ret.guarana
  };
};

function isIos() {
  var ua = navigator.userAgent;
  return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}

function isAndroid() {
  var ua = navigator.userAgent;
  return ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
}

function isFusionKit() {
  return app.fusionKit;
};

function inApp() {
  var ua = navigator.userAgent;
  return (/didi\.passenger/i.test(ua)
  );
};

function compareAppVersion() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  switch (args.length) {
    case 2:
      return compare(app.version, args[0], args[1]);
    case 3:
      return compare.apply(null, args);
  }
};

function compareSysVersion() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  switch (args.length) {
    case 2:
      return compare(app.sysVersion, args[0], args[1]);
    case 3:
      return compare.apply(null, args);
  }
};

function compare(v1, symbol, v2) {
  v1 = parse(v1);
  v2 = parse(v2);
  if (symbol.indexOf('=') !== -1 && v1 === v2) {
    return true;
  }
  if (symbol.indexOf('>') !== -1 && v1 > v2) {
    return true;
  }
  if (symbol.indexOf('<') !== -1 && v1 < v2) {
    return true;
  }
  return false;
};

function parse() {
  var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  version = version.split('.');
  version.length = 4;

  var ret = [];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["each"])(version, function (n) {
    n = n * 1;
    if (n) {
      ret.push(n >= 10 ? n : '0' + n);
    } else {
      ret.push('00');
    }
  });
  return parseInt(ret.join(''), 10);
}

/***/ }),

/***/ "SJHH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Global; });
var Global = function () {
  var instance = void 0;

  function init() {
    return {
      modules: {},
      callbacks: {},
      callbackId: '0'
    };
  }
  return {
    getInstance: function getInstance() {
      if (!instance) {
        instance = init();
      }
      return instance;
    }
  };
}();

/***/ }),

/***/ "SgM5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = makeBridgeFn;
/* harmony export (immutable) */ __webpack_exports__["b"] = init;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("pMqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_api_app__ = __webpack_require__("SFol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ios__ = __webpack_require__("w+yi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__android__ = __webpack_require__("scgg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__fusion_src_fusion__ = __webpack_require__("KPKY");

/**
 * call 封装
 */

var theWindow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["getWindow"])();







// 引入fusion支持

// const Fusion = require('../fusion/fusion');

theWindow.Fusion = __WEBPACK_IMPORTED_MODULE_5__fusion_src_fusion__["a" /* default */];
/**
 * 根据config创建JSBridge方法
 * @param conf 配置文件
 * @returns {Function}
 */
function makeBridgeFn(name, conf) {
  return function () {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__util__["noop"];

    if (arguments.length === 1 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["isFn"])(param)) {
      callback = param;
      param = {};
    }

    var fn = conf ? conf.fn : name;
    call(fn, param, callback);
  };
};

function init() {
  var triggerName = '__bridgeTrigger__';

  theWindow[triggerName] = function (retData) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["isStr"])(retData)) {
      try {
        retData = JSON.parse(retData);
      } catch (e) {
        retData = {};
      }
    }
    var eventName = retData.eventname;
    var errno = retData.errno;
    var err = null;
    if (errno !== __WEBPACK_IMPORTED_MODULE_1__util__["ERR_OK"]) {
      var msg = retData.errmsg;
      err = new Error(msg);
    }
    __WEBPACK_IMPORTED_MODULE_1__util__["events"].emit(eventName, err, retData.result);
  };

  call('initConfig', {
    handler: triggerName
  }, __WEBPACK_IMPORTED_MODULE_1__util__["noop"]);
}

function call(fn, param, callback) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__global_api_app__["d" /* inApp */])()) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__global_api_app__["b" /* isFusionKit */])() && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["isUndefined"])(theWindow.Fusion) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["isUndefined"])(theWindow.Fusion[fn])) {
      var triggerName = '__fusionBridgeCall__';
      theWindow[triggerName] = function (ret) {
        if (ret) {
          var err = null;
          callback.length === 1 ? callback(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(ret)) : callback(err, ret);
        }
      };
      theWindow.Fusion[fn](param, theWindow[triggerName]);
    } else {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__global_api_app__["f" /* isAndroid */])()) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__android__["a" /* callAndroid */])(fn, param, callback);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__ios__["a" /* callIOS */])(fn, param, callback);
      }
    }
  }
}

/***/ }),

/***/ "Wf0K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getOldParamAlias;
/* harmony export (immutable) */ __webpack_exports__["a"] = alias;
/**
 * alias 处理
 */

function getOldParamAlias(param) {
    if (param.type && param.type === 'image') {
        // 大图分享之前版本不支持不做任何处理
    } else {
        param.share_title = param.title;
        param.share_content = param.content;
        param.share_url = param.url;
        param.share_icon_url = param.icon;
    }

    return param;
}
function alias(name, param, conf, allConf) {
    if (name.indexOf('share') === 0) {
        name = conf.alias ? conf.alias : conf.fn;
        param = getOldParamAlias(param);
    } else if (name === 'setTitle') {
        name = conf.alias ? conf.alias : conf.fn;
        param.navi_title = param.title;
    } else {
        conf ? name = conf.alias ? conf.alias : conf.fn : name;
    }
    return {
        name: name,
        param: param
    };
}

/***/ }),

/***/ "WxI/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__("kpqR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_resource__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_inobounce__ = __webpack_require__("+s85");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_inobounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_inobounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ramda__ = __webpack_require__("ivXw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App__ = __webpack_require__("3ytO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router__ = __webpack_require__("QVuP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__bridge__ = __webpack_require__("l10z");





var _this = this;










// import suggest from 'suggest'

// import FastClick from 'fastclick'
// FastClick.attach(document.body);


console.log(__WEBPACK_IMPORTED_MODULE_12__bridge__["a" /* ddbridgedriver */], __WEBPACK_IMPORTED_MODULE_12__bridge__["b" /* ddbridgebeatles */]);

// alert(window.navigator.userAgent.toLowerCase());
var isIOS = window.didi.is('ios');

window.setTitle = function (title) {
  if (isIOS) {
    if (__WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('driver')) {
      __WEBPACK_IMPORTED_MODULE_12__bridge__["a" /* ddbridgedriver */].call('controllerTitle', { vctitle: title });
    }
    // 主端 顺风车，顺风车独立端
    if (__WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('blord') || __WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('beatles')) {
      __WEBPACK_IMPORTED_MODULE_12__bridge__["b" /* ddbridgebeatles */].updateNaviTitle({
        navi_title: title
      });
    }
  } else {
    window.document.title = title;
  }
};

// 孙昊 2018-07-25
var parseJson = function parseJson(data) {
  if (data.constructor.name === 'String') {
    return JSON.parse(data);
  }
  return data;
};

// 孙昊 2018-07-25
// ddbridge、ddbridgebeatles、ddbridgedriver 均可单独调用
// tools 下的方法均已抹平容器判断。直接调用即可
window.epowerTools = {
  ddbridge: __WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */],
  ddbridgebeatles: __WEBPACK_IMPORTED_MODULE_12__bridge__["b" /* ddbridgebeatles */],
  ddbridgedriver: __WEBPACK_IMPORTED_MODULE_12__bridge__["a" /* ddbridgedriver */],
  tools: {
    getLocationInfo: function getLocationInfo(cb) {
      if (__WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('driver')) {
        __WEBPACK_IMPORTED_MODULE_12__bridge__["a" /* ddbridgedriver */].call('getLocationInfo', function (res) {
          cb(parseJson(res));
        });
      } else if (__WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('blord') || __WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('beatles')) {
        // 顺风车
        __WEBPACK_IMPORTED_MODULE_12__bridge__["b" /* ddbridgebeatles */].getLocationInfo(function (res) {
          cb(parseJson(res));
        });
      } else {
        cb({ cityid: 1 });
      }
    },
    getUserInfo: function getUserInfo(cb) {
      if (__WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('driver')) {
        __WEBPACK_IMPORTED_MODULE_12__bridge__["a" /* ddbridgedriver */].call('getUserInfo', function (res) {
          cb(parseJson(res));
        });
      } else if (__WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('blord') || __WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('beatles')) {
        // 顺风车
        __WEBPACK_IMPORTED_MODULE_12__bridge__["b" /* ddbridgebeatles */].getUserInfo(function (res) {
          cb(parseJson(res));
        });
      }
    },
    initEntrance: function initEntrance(params, cb) {
      if (__WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('driver')) {
        __WEBPACK_IMPORTED_MODULE_12__bridge__["a" /* ddbridgedriver */].call('initEntrance', params, function (res) {
          if (cb) {
            cb(res);
          }
        });
      } else if (__WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('blord') || __WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('beatles')) {
        // 顺风车
        __WEBPACK_IMPORTED_MODULE_12__bridge__["b" /* ddbridgebeatles */].initEntrance(params, function (res) {
          if (cb) {
            cb(res);
          }
        });
      }
    },
    invokeEntrance: function invokeEntrance() {
      if (__WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('driver')) {
        __WEBPACK_IMPORTED_MODULE_12__bridge__["a" /* ddbridgedriver */].call('invokeEntrance');
      } else if (__WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('blord') || __WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('beatles')) {
        // 顺风车
        __WEBPACK_IMPORTED_MODULE_12__bridge__["b" /* ddbridgebeatles */].invokeEntrance();
      }
    },
    launchScan: function launchScan() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cb = arguments[1];

      // 扫码
      // 孙昊 2018-07-25
      // 车生活 司机端
      if (__WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('driver>=5.0.22')) {
        __WEBPACK_IMPORTED_MODULE_12__bridge__["a" /* ddbridgedriver */].call('launchScan', params, function (res) {
          if (cb) {
            cb(parseJson(res));
          }
        });
      } else if (__WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('beatles>=5.2.12') || __WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('blord>=2.0')) {
        __WEBPACK_IMPORTED_MODULE_12__bridge__["b" /* ddbridgebeatles */].callNative('scanQRCode', {}, function (res) {
          // alert(parseJson(res).data);
          cb({ ret: parseJson(res).data });
        });
      } else {
        // 都不支持扫码
        alert('软件版本过低！请升级！');
      }
    },
    launchNav: function launchNav() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      // 唤起路径规划
      if (__WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('driver')) {
        __WEBPACK_IMPORTED_MODULE_12__bridge__["a" /* ddbridgedriver */].call('launchNav', params);
      } else if (__WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('blord') || __WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('beatles')) {
        // 顺风车
        // ddbridgebeatles.callNative('launchNav', params);
        __WEBPACK_IMPORTED_MODULE_12__bridge__["b" /* ddbridgebeatles */].launchNav(params);
      }
    },
    openPage: function openPage(url) {
      if (__WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('driver')) {
        __WEBPACK_IMPORTED_MODULE_12__bridge__["a" /* ddbridgedriver */].call('openPage', {
          url: url,
          newWindow: true,
          browser: false,
          isArouseRadio: true
        });
      } else if (__WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('blord') || __WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('beatles')) {
        // 顺风车
        __WEBPACK_IMPORTED_MODULE_12__bridge__["b" /* ddbridgebeatles */].schemes.jump('/beatles_webpage', {
          weburl: url
        });
      }
    },
    closePage: function closePage() {
      if (__WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('driver')) {
        __WEBPACK_IMPORTED_MODULE_12__bridge__["a" /* ddbridgedriver */].call('pageClose');
      } else if (__WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('blord') || __WEBPACK_IMPORTED_MODULE_12__bridge__["c" /* ddbridge */].is('beatles')) {
        // 顺风车
        __WEBPACK_IMPORTED_MODULE_12__bridge__["b" /* ddbridgebeatles */].closePage();
      }
    }
  }
};

__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource___default.a);
// Vue.use(suggest);

__WEBPACK_IMPORTED_MODULE_11__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.meta.title) {
    window.setTitle(to.meta.title);
  }
  next();
});

// window.$originV = new Vue({
//   el: '#app',
//   router,
//   store,
//   template: '<App/>',
//   components: { App }
// });

// function getCity() {
//   return new Promise((resolve, reject) => {
//     if(didi.dbridge.support('getLocationInfo')){
//       didi.dbridge.getLocationInfo(function(result){
//         axios.get("/station-api/station/getcityinfo?lat=" + result.lat + "&lng=" + result.lng).then((response) => {
//           resolve(response.data.data);
//         })
//       })
//     }else{
//       resolve({cityid: 1});
//     }
//   })
// }

// 获取城市的方法
var getCityInfo = function getCityInfo(params, cb) {
  var lat = params.lat,
      lng = params.lng;

  __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('https://gw.am.xiaojukeji.com/station-api/station/getcityinfo?lat=' + lat + '&lng=' + lng, { headers: { ticket: params.ticket } }).then(function (response) {
    cb(response.data.data);
  }, function () {
    cb({
      cityid: 1,
      cityname: '北京'
    });
  });
};

// alert(JSON.stringify(ddbridge.app));

// 从端内获取城市信息
var getCity = function getCity(ticket) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
    window.epowerTools.tools.getLocationInfo(function (res) {
      var params = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, res, { ticket: ticket });
      getCityInfo(params, function (data) {
        resolve(data);
      });
    });
  });
};

function getUid(tk) {
  __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('https://gw.am.xiaojukeji.com/station-api/common/queryuserbytoken?token=' + tk, { headers: { ticket: tk } }).then(function (res) {
    if (res && res.data && res.data.data && res.data.data.errno === 0) {
      window.epuid = res.data.data.uid;
    }
  });
}

function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r !== null) {
    return unescape(r[2]);
  }
  return null;
}

var getUserInfo = function getUserInfo() {
  var source = getQueryString('source');
  var stationId = getQueryString('stationId');
  var ticket = getQueryString('token');
  var phone = getQueryString('phone');
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
    if (window.location.search.indexOf('debug') !== -1) {
      resolve({
        ticket: ticket,
        phone: phone,
        source: source,
        stationId: stationId
      });
      getUid(ticket);
    } else {
      window.epowerTools.tools.getUserInfo(function (res) {
        var result = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, res, {
          source: source,
          stationId: stationId
        });
        resolve(result);
        getUid(result.ticket);
      });
    }
  });
};

// function getA3() {
//   return new Promise((resolve, reject) => {
//     if(didi.dbridge.support('getA3Token')){
//       didi.dbridge.getA3Token(function(result){
//         resolve(result);
//       })
//     }else{
//       resolve({});
//     }
//   })
// }

function vueInit(ticket, phone, source, stationId, cityid, cityname, a3, imei, isAllow) {
  // vuex 初始化
  var store = new __WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */].Store({
    state: {
      source: source,
      isAllow: isAllow,
      token: ticket,
      phone: phone,
      cityName: cityname,
      cityId: cityid,
      a3: a3,
      imei: imei,
      userPosition: {},
      stateData: {
        lat: 40.04387586805556,
        lng: 116.28963460286458,
        type: 2,
        distance: 5
      },
      stationListData: [],
      cardboxState: 0,
      showStationDetail: false,
      stationDetailData: {},
      orderInfo: {
        orderStatus: -1
      },
      qrCodeInfo: {},
      infoPics: {
        current: null,
        showPics: false,
        pics: []
      },
      findstationDoing: false,
      errDialogInfo: {
        show: false
      },
      elecPriceInfo: {},
      showChargeState: true,
      pricePopupInfo: {
        show: false,
        priceInfos: []
      },
      feedbackPopupInfo: {
        show: false
      },
      achieveInfo: [],
      totalBalance: 0.0,
      // 搜索后直接展示详情页的宏操作开关
      showDetailMacroSwitch: false, // false || string: id
      redPoint: {},
      // 桩站id
      fullStationId: stationId,
      // 首次进入
      firstEntry: 0,
      eVIsFetching: true
    },
    mutations: {
      fullStationIdChange: function fullStationIdChange(state, newData) {
        state.fullStationId = newData;
      },
      firstEntryChange: function firstEntryChange(state, newData) {
        state.firstEntry = newData;
      },
      changeShowDetailMacroSwitch: function changeShowDetailMacroSwitch(state, newData) {
        state.showDetailMacroSwitch = newData;
      },
      changeRedPoint: function changeRedPoint(state, newData) {
        state.redPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_ramda__["a" /* merge */])(state.redPoint, newData);
      },
      changeTotalBalance: function changeTotalBalance(state, newData) {
        state.totalBalance = newData;
      },
      changeAchieveInfo: function changeAchieveInfo(state, newData) {
        state.achieveInfo = newData;
      },
      changePricePopupInfo: function changePricePopupInfo(state, newData) {
        state.pricePopupInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_ramda__["a" /* merge */])(state.pricePopupInfo, newData);
      },
      changeFeedbackPopupInfo: function changeFeedbackPopupInfo(state, newData) {
        state.feedbackPopupInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_ramda__["a" /* merge */])(state.feedbackPopupInfo, newData);
      },
      changeUserPosition: function changeUserPosition(state, newData) {
        state.userPosition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_ramda__["a" /* merge */])(state.userPosition, newData);
      },
      changeShowChargeState: function changeShowChargeState(state, newData) {
        state.showChargeState = newData;
      },
      tokenChanged: function tokenChanged(state, newData) {
        state.token = newData;
      },
      dataChanged: function dataChanged(state, newData) {
        state.stateData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_ramda__["a" /* merge */])(state.stateData, newData);
      },
      dataCover: function dataCover(state, newData) {
        state.stateData = newData;
      },
      stationListDataChanged: function stationListDataChanged(state, newData) {
        state.stationListData = newData;
      },
      cardboxStateChanged: function cardboxStateChanged(state, newData) {
        state.cardboxState = newData;
      },
      stationDetailDataChanged: function stationDetailDataChanged(state, newData) {
        state.stationDetailData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_ramda__["a" /* merge */])(state.stationDetailData, newData);
      },
      showStationDetailChanged: function showStationDetailChanged(state, newData) {
        state.showStationDetail = newData;
      },
      orderInfoChanged: function orderInfoChanged(state, newData) {
        /*newData.stationName || (newData.stationName = state.orderInfo.stationName);
        newData.soc || (newData.soc = state.orderInfo.soc);*/
        state.orderInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_ramda__["a" /* merge */])(state.orderInfo, newData);
      },
      qrCodeInfoChanged: function qrCodeInfoChanged(state, newData) {
        state.qrCodeInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_ramda__["a" /* merge */])(state.qrCodeInfo, newData);
      },
      infoPicsChanged: function infoPicsChanged(state, newData) {
        state.infoPics = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_ramda__["a" /* merge */])(state.infoPics, newData);
      },
      findstationDoingChanged: function findstationDoingChanged(state, newData) {
        state.findstationDoing = newData;
      },
      errDialogInfoChanged: function errDialogInfoChanged(state, newData) {
        state.errDialogInfo = newData;
      },
      showTopHornChanged: function showTopHornChanged(state, newData) {
        state.showTopHorn = newData;
      },
      elecPriceChange: function elecPriceChange(state, newData) {
        state.elecPriceInfo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_ramda__["a" /* merge */])(state.elecPriceInfo, newData);
      },
      eVIsFetchingChange: function eVIsFetchingChange(state, newData) {
        state.eVIsFetching = newData;
      }
    },
    actions: {
      getOneInfo: function getOneInfo(_ref, searchDetailData) {
        var state = _ref.state;

        return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get('https://gw.am.xiaojukeji.com/station-api/station/getoneinfo', { params: searchDetailData, headers: { ticket: searchDetailData.token } }).then(function (res) {
            resolve(res.data.data);
          });
        });
      },
      getConnectorList: function getConnectorList(_ref2, connectorData) {
        var state = _ref2.state;

        return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post('https://gw.am.xiaojukeji.com/station-api/connector/querylist', connectorData, {
            headers: { ticket: connectorData.token }
          }).then(function (res) {
            resolve(res.data.data);
          });
        });
      },
      showDetail: function showDetail(_ref3, fullStationId) {
        var dispatch = _ref3.dispatch,
            commit = _ref3.commit,
            state = _ref3.state;

        commit('findstationDoingChanged', true);
        var searchDetailData = {
          fullstationid: fullStationId,
          token: state.token,
          lat: state.stateData.lat,
          lng: state.stateData.lng,
          userlat: state.userPosition.lat,
          userlng: state.userPosition.lng,
          source: state.source
        };
        var connectorData = {
          fullStationId: fullStationId,
          token: state.token
        };
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([dispatch('getOneInfo', searchDetailData), dispatch('getConnectorList', connectorData)]).then(function (res) {
          commit('showStationDetailChanged', true);
          commit('findstationDoingChanged', false);
          commit('stationDetailDataChanged', res[0]);
          commit('stationDetailDataChanged', res[1]);
        });
      }
    }
  });

  document.cookie = 'ticket=' + ticket + ';path=/';

  // omega 初始化
  window.Omega.enableClickFilterTracker({
    attr: 'track-data'
  });

  window.Omega.addTrackHandler(function () {
    if (!window.epower_cid) {
      window.epower_cid = getQueryString('epower_cid') || '';
    }
    return {
      cityid: cityid,
      area: cityname,
      epower_cid: window.epower_cid,
      uid: window.epuid
    };
  });

  window.Omega.trackEvent('charge_loading_page_sw');
  var v = new __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_11__router__["a" /* default */],
    store: store,
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_10__App__["a" /* default */] }
  });
}

var run = function () {
  var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    var _ref5, ticket, phone, source, stationId, _ref6, cityid, cityname;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getUserInfo();

          case 2:
            _ref5 = _context.sent;
            ticket = _ref5.ticket;
            phone = _ref5.phone;
            source = _ref5.source;
            stationId = _ref5.stationId;
            _context.next = 9;
            return getCity(ticket);

          case 9:
            _ref6 = _context.sent;
            cityid = _ref6.cityid;
            cityname = _ref6.cityname;

            window.Apollo.getToggle({
              // debug: true,
              name: 'entrance_admin',
              key: ticket,
              phone: phone,
              city: cityid
            }, function (result) {
              if (!result.code) {
                var ABTest = result.data.entrance_admin;

                // alert(`${JSON.stringify({ticket, phone, source, stationId, cityid, cityname})}`);
                if (ABTest.isAllow()) {
                  vueInit(ticket, phone, source, stationId, cityid, cityname, null, null, true);
                } else {
                  vueInit(ticket, phone, source, stationId, cityid, cityname, null, null, false);
                }
              }
            });

          case 13:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function run() {
    return _ref4.apply(this, arguments);
  };
}();
run();

// Promise.all([getUserInfo(), getCity()]).then((res) => {
//   const [
//     {
//       ticket,
//       phone,
//       source,
//       stationId,
//     },
//     { cityid, cityname },
//   ] = res;
//   alert(`init:${JSON.stringify(res)}`);
//   window.Apollo.getToggle({
//     // debug: true,
//     name: 'entrance_admin',
//     key: ticket,
//     phone,
//     city: cityid,
//   }, (result) => {
//     if (!result.code) {
//       const ABTest = result.data.entrance_admin;
//       if (ABTest.isAllow()) {
//         vueInit(ticket, phone, source, stationId, cityid, cityname, null, null, true);
//       } else {
//         vueInit(ticket, phone, source, stationId, cityid, cityname, null, null, false);
//       }
//     }
//   });
// });

/***/ }),

/***/ "XaO8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DDBridgeDriver; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("P/rs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__("E0e7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_bridge__ = __webpack_require__("/rjl");
/**
 * 司机端 DidiJSBridge 封装
 * @author xuxiaoyan
 */





var DDBridgeDriver = {};

var defaultFn = function defaultFn() {};

function call(method) {
  var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultFn;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["a" /* invokeInTurn */])(_call, arguments);
}

function _call(method) {
  var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultFn;

  setTimeout(function () {
    // hack
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_bridge__["a" /* bridgeReady */])(function (bridge) {
      bridge.callHandler(method, param, function (data) {
        if (typeof data == 'string') {
          data = JSON.parse(data);
        }
        callback(data);
      });
    });
  }, 0);
}

/**
 * 根据config创建JSBridge方法
 * @param conf 配置文件
 * @returns {Function}
 */
function driverBridgeFn(name, conf, args) {
  return function () {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFn;

    if (arguments.length === 1 && typeof param === 'function') {
      callback = param;
      param = {};
    }

    var method = conf ? conf.fn : name,
        prepare = conf ? conf.prepare : null;

    // 是否支持该方法判断
    // 暂时缺省

    if (prepare && typeof prepare === 'function') {
      call.apply(null, prepare.apply(null, args));
    } else if (name) {
      call(method, param, callback);
    }
  };
}

/**
 * 司机端基础的Bridge.call(method, param, callback)方法
 * @param DDBridge
 */
function initDriverBaseCall(DDBridge) {
  DDBridge.call = function (method) {
    var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultFn;


    var conf = __WEBPACK_IMPORTED_MODULE_1__config__["b" /* driverConfig */][method],
        args = Array.prototype.slice.call(arguments, 0),
        bridgeFn = driverBridgeFn(method, conf, args);

    if ((!callback || callback === defaultFn) && typeof param === 'function') {
      callback = param;
      param = {};
    }

    return bridgeFn(param, callback);
  };
}

initDriverBaseCall(DDBridgeDriver);



/***/ }),

/***/ "a+k9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = callAndroid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_index__ = __webpack_require__("P/rs");

/**
 * prompt 封装, Andrid大于4.2.0版本均可以用
 * @author huangyiustb
 * @modify xuxiaoyan
 * http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=75128588
 */



var __uid = 0;

function callAndroid(fn, param, callback) {
  var id = __uid++;
  var callbackName = '__bridgeCall__' + id;

  var message = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    cmd: fn,
    id: id,
    params: param,
    callback: callbackName
  });

  window[callbackName] = function (retData) {
    var errno = retData.errno;
    var err = null;
    if (errno !== __WEBPACK_IMPORTED_MODULE_1__util_index__["i" /* ERR_OK */]) {
      var msg = retData.errmsg;
      err = { errno: retData.errno, errmsg: retData.errmsg };
    }
    // 分享面板会统一执行这个回调
    fn !== 'showEntrance' && delete window[callbackName];

    // node style
    callback(err, retData.result || retData);
  };

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_index__["e" /* logger */])({
    pos: 'ANDROID_SEND_MSG',
    message: message
  });

  window.prompt(message);
}

// export const supportPrompt = isAndroid && compareVersion('>4.2.0');

/***/ }),

/***/ "cemT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("+IIN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("pMqq");
/**
 * 封装scheme协议
 * 详细参数见：http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=12222556
 * 使用方法如：schemes.jump('/beatles_homepage', { userrole: 2 }); 跳到车主tab
 */



var theWindow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["getWindow"])();

var schemes = {};

// scheme协议域名
var protocolBlord = 'dhitch:'; // 顺风车独立端协议
var protocolDidi = 'diditravel:'; // 滴滴端协议
var schemeProtocol = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["j" /* inBlord */])() ? protocolBlord : protocolDidi;
var schemeOrigin = schemeProtocol + '//com.didi.passengerapp';

/**
 * 跳转scheme
 * @param {String} path scheme的路径，即在diditravel://com.didi.passengerapp之后的path，这样可以自由扩展path不必修改bridge
 * @param {Object} params 传递的参数，会自动转为query
 */
schemes.jump = function (path, params) {
  params = params || {};
  params.productid = 259;
  var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["k" /* obj2Query */])(params);
  var urlScheme = schemeOrigin + path;
  theWindow.location.href = urlScheme + '?' + query;
};

/* harmony default export */ __webpack_exports__["a"] = (schemes);

/***/ }),

/***/ "jsdW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initIS;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("pMqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__("SFol");
/**
 * is方法的实现, 类似media query的bnf
 * tokenize + parse
 * BNF:
 * rule_list: <rule>[,<rule>]*
 * rule: <expression>[and <expression>]*
 * expression:(<identity>[<operator><version>]?)
 * identity:ios|android|passenger|driver|lite
 * operator: > | < | = | >= | <=
 * version: [\d\.]
 *
 */




var identRE = /^\w+/;
var versionRE = /^[\d\._]+/;
var opRE = /^\s*[>=<]+\s*/;
var commaRE = /^\s*,\s*/;
var andRE = /^\s*and\s*/;

var ERR_IDENTITY = 0;
var ERR_VERSION = 1;

var errMsg = ['identity is not valid', 'version is not valid'];

var SYSTEM = 0;
var APP = 1;

var identityList = {
	passenger: {
		type: APP,
		compare: __WEBPACK_IMPORTED_MODULE_1__app__["c" /* compareAppVersion */]
	},
	driver: {
		type: APP,
		compare: __WEBPACK_IMPORTED_MODULE_1__app__["c" /* compareAppVersion */]
	},
	lite: {
		type: APP,
		compare: __WEBPACK_IMPORTED_MODULE_1__app__["c" /* compareAppVersion */]
	},
	ios: {
		type: SYSTEM,
		compare: __WEBPACK_IMPORTED_MODULE_1__app__["g" /* compareSysVersion */]
	},
	android: {
		type: SYSTEM,
		compare: __WEBPACK_IMPORTED_MODULE_1__app__["g" /* compareSysVersion */]
	}
};

// let tokenCache = {};
function initIS(D) {
	D.is = function (rule) {
		try {
			var groups = tokenize(rule);
			return parse(groups);
		} catch (e) {
			console.error(e.message);
		}
	};
};

/**
 * 词法分析
 * @param rule
 * @example 'passenger'
 * @example 'passenger>=5.0'
 * @example 'passenger>=5.0 and ios>9.3.2'
 * @example 'passenger>=5.0 and ios>9.3.2, driver >=3.0, lite >=1.0'
 * @return Array
 */
function tokenize(rule) {
	// if (tokenCache[rule]) {
	// 	return tokenCache[rule];
	// }
	var soFar = rule;
	// 根据comma分组
	var groups = [];
	var matched = void 0;

	while (soFar) {
		var tokens = void 0;
		var match = commaRE.exec(soFar);
		if (!matched || match) {
			// 删除comma
			if (match) {
				soFar = soFar.slice(match[0].length) || soFar;
			}
			tokens = [];
			groups.push(tokens);
		}

		matched = false;

		var more = true;
		var error = false;
		// 解析每个表达式
		do {
			var expression = {};
			// 拿到identity
			match = identRE.exec(soFar);
			if (match) {
				matched = match.shift();
				expression.identity = matched;
				soFar = soFar.slice(matched.length);
			} else {
				error = ERR_IDENTITY;
				break;
			}
			// 再尝试拿操作符
			match = opRE.exec(soFar);
			if (match) {
				matched = match.shift();
				expression.operator = matched.trim();
				soFar = soFar.slice(matched.length);

				// 如果有操作符,就必须有版本号
				match = versionRE.exec(soFar);
				if (match) {
					matched = match.shift();
					expression.version = matched;
					soFar = soFar.slice(matched.length);
				} else {
					error = ERR_VERSION;
					break;
				}
			}
			tokens.push(expression);
			// 最后拿and
			match = andRE.exec(soFar);
			if (match) {
				matched = match.shift();
				soFar = soFar.slice(matched.length);
				more = true;
			} else {
				more = false;
			}
		} while (more);

		if (error !== false) {
			throw new Error('the rule is error, ' + errMsg[error]);
		}
	}
	// cache
	// tokenCache[rule] = groups;
	return groups;
}

/**
 * 解析词法分析的结果
 * @param group
 * @return Boolean
 */
function parse(groups) {
	var ret = false;
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["each"])(groups, function (tokens) {
		var result = true;
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["each"])(tokens, function (expression) {
			var identity = expression.identity,
			    operator = expression.operator,
			    version = expression.version;
			// 白名单

			var ident = identityList[identity];
			if (!ident) {
				throw new Error('unknown identity:' + identity + '!');
			}
			var equal = false;
			var type = ident.type;
			if (type === SYSTEM) {
				equal = __WEBPACK_IMPORTED_MODULE_1__app__["e" /* app */].system === identity;
			} else if (type === APP) {
				equal = __WEBPACK_IMPORTED_MODULE_1__app__["e" /* app */].env === identity;
			}
			if (!operator || !equal) {
				result = result && equal;
			} else {
				var compareFn = ident.compare;
				result = result && compareFn(operator, version);
			}
		});
		ret = ret || result;
	});
	return ret;
}

/***/ }),

/***/ "l10z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ddbridge__ = __webpack_require__("oRZP");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__ddbridge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ddbridgepassenger__ = __webpack_require__("3KX6");
/* unused harmony reexport ddbridgepassenger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ddbridgefinance__ = __webpack_require__("0JGz");
/* unused harmony reexport ddbridgefinance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ddbridgedriver__ = __webpack_require__("XaO8");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__ddbridgedriver__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ddbridgedaijiadriver__ = __webpack_require__("3Ufk");
/* unused harmony reexport ddbridgedaijiadriver */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ddbridgebeatles__ = __webpack_require__("8mjE");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__ddbridgebeatles__["a"]; });







/***/ }),

/***/ "lnYr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERR_OK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ERR_FUNCTION_NOT_EXIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ERR_CALLBACK_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ERR_ENV_ERROR; });
/**
 * 常见的错误码
 *
 */

var ERR_OK = 0;

var ERR_FUNCTION_NOT_EXIST = 1001;

var ERR_CALLBACK_ERROR = 1002;

var ERR_ENV_ERROR = 2001;

/***/ }),

/***/ "lsjZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = callIOS;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("P/rs");

/**
 * prompt 封装
 * @author huangyiustb
 * @modify xuxiaoyan
 * http://wiki.intra.xiaojukeji.com/pages/viewpage.action?pageId=75128588
 */



var schema = 'didibridge://BRIDGE_CALL?callback=',
    msgFrame = null;

var __uid = 0;

function createFrame(src) {
  var frame = document.createElement('IFRAME');
  frame.id = 'mfe-webview-util-iframe';
  frame.style.display = 'none';
  frame.src = src;
  document.body.appendChild(frame);
  return frame;
}

function callIOS(fn, param, callback) {
  var id = __uid++;
  var callbackName = '__bridgeCall__' + id;

  var callData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    cmd: fn,
    id: id,
    params: param,
    callback: callbackName
  });

  var callDataName = '__getCallData__' + id;
  window[callDataName] = function () {
    delete window[callDataName];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* logger */])({
      pos: 'IOS_RETURN_JSON',
      callDataName: callDataName
    });
    return callData;
  };

  window[callbackName] = function (retData) {

    if (typeof retData === 'string') {
      try {
        retData = JSON.parse(retData);
      } catch (e) {
        retData = {};
      }
    }
    // compatibility for Fusion
    var errno = retData.errno !== undefined ? retData.errno : retData.errorno;
    var errmsg = retData.errmsg !== undefined ? retData.errmsg : retData.errormsg;

    var err = +errno !== __WEBPACK_IMPORTED_MODULE_1__util__["i" /* ERR_OK */] ? { errno: errno, errmsg: errmsg } : null;

    delete window[callbackName];

    // node style
    callback(err, retData.result || retData);
  };

  // do send
  var src = schema + callDataName;
  send(src);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["e" /* logger */])({
    pos: 'IOS_SEND_MSG',
    src: src
  });
}

function send(src) {

  if (!msgFrame) {
    msgFrame = createFrame(src);
  } else {
    msgFrame.src = src;
  }
}

/***/ }),

/***/ "mlBL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initBeatles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__extendApi__ = __webpack_require__("3OnU");


function initBeatles(DDBridge) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__extendApi__["a" /* extendBeatlesAPI */])(DDBridge);
}

/***/ }),

/***/ "oEoL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isFn;
/* harmony export (immutable) */ __webpack_exports__["b"] = isStr;
/* harmony export (immutable) */ __webpack_exports__["c"] = isObj;
/* harmony export (immutable) */ __webpack_exports__["d"] = isArray;
/* harmony export (immutable) */ __webpack_exports__["e"] = isUndefined;
/* harmony export (immutable) */ __webpack_exports__["f"] = each;
/* harmony export (immutable) */ __webpack_exports__["g"] = camelize;
/* harmony export (immutable) */ __webpack_exports__["h"] = noop;
/**
 * 基础js方法的封装
 *
 */

function typeEqual(obj, type) {
	return Object.prototype.toString.call(obj) === '[object ' + type + ']';
}

function isFn(obj) {
	return typeEqual(obj, 'Function');
};

function isStr(obj) {
	return typeEqual(obj, 'String');
};

function isObj(obj) {
	return typeEqual(obj, 'Object');
};

function isArray(obj) {
	return typeEqual(obj, 'Array');
};

function isUndefined(obj) {
	return typeEqual(obj, 'Undefined');
};

function each(obj, fn, context) {
	if (!obj || !isFn(fn)) {
		return;
	}
	context = context || obj;

	if (isArray(obj)) {
		for (var i = 0, l = obj.length; i < l; i++) {
			if (fn.call(context, obj[i], i, obj) === false) {
				return;
			}
		}
	} else if (isObj(obj)) {
		for (var n in obj) {
			if (fn.call(context, obj[n], n, obj) === false) {
				return;
			}
		}
	}
};

var camelizeRE = /_(\w)/g;
function camelize(str) {
	return str.replace(camelizeRE, toUpper);
}

function toUpper(_, c) {
	return c ? c.toUpperCase() : '';
}

function noop() {};

/***/ }),

/***/ "oRZP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DDBridge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__("4gy1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__("0JXT");
/**
 * 初始化全局api
 * @author huangyiustb
 * @modify xuxiaoyan
 */



var DDBridge = {};

function initGlobalAPI(DDBridge) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__app__["b" /* initApp */])(DDBridge);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is__["a" /* initIS */])(DDBridge);
}

initGlobalAPI(DDBridge);



/***/ }),

/***/ "pMqq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lang__ = __webpack_require__("oEoL");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isFn", function() { return __WEBPACK_IMPORTED_MODULE_0__lang__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isStr", function() { return __WEBPACK_IMPORTED_MODULE_0__lang__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isObj", function() { return __WEBPACK_IMPORTED_MODULE_0__lang__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isArray", function() { return __WEBPACK_IMPORTED_MODULE_0__lang__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isUndefined", function() { return __WEBPACK_IMPORTED_MODULE_0__lang__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "each", function() { return __WEBPACK_IMPORTED_MODULE_0__lang__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "camelize", function() { return __WEBPACK_IMPORTED_MODULE_0__lang__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "noop", function() { return __WEBPACK_IMPORTED_MODULE_0__lang__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errno__ = __webpack_require__("lnYr");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ERR_OK", function() { return __WEBPACK_IMPORTED_MODULE_1__errno__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ERR_FUNCTION_NOT_EXIST", function() { return __WEBPACK_IMPORTED_MODULE_1__errno__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ERR_CALLBACK_ERROR", function() { return __WEBPACK_IMPORTED_MODULE_1__errno__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ERR_ENV_ERROR", function() { return __WEBPACK_IMPORTED_MODULE_1__errno__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom__ = __webpack_require__("KJQd");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "createFrame", function() { return __WEBPACK_IMPORTED_MODULE_2__dom__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "getWindow", function() { return __WEBPACK_IMPORTED_MODULE_2__dom__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__events__ = __webpack_require__("1G11");
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "events", function() { return __WEBPACK_IMPORTED_MODULE_3__events__["a"]; });





/***/ }),

/***/ "rpWB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * 配置文件
 */

var config = {
    debug: false,
    /**
     * 所有支持的接口集合
     */
    api: {
        initEntrance: {
            fn: 'initEntrance',
            alias: 'init_entrance'
        },

        invokeEntrance: {
            fn: 'invokeEntrance',
            alias: 'invoke_entrance'
        },

        showEntrance: {
            fn: 'showEntrance',
            alias: 'show_entrance'
        },

        hideEntrance: {
            fn: 'hideEntrance',
            alias: 'hide_entrance'
        },

        shareWeixinTimeline: {
            fn: 'shareWeixinTimeline',
            alias: 'share_weixin_timeline'
        },

        shareWeixinAppmsg: {
            fn: 'shareWeixinAppmsg',
            alias: 'share_weixin_appmsg'
        },

        shareAlipayLife: {
            fn: 'shareAlipayLife'
        },

        shareAlipayFriend: {
            fn: 'shareAlipayFriend'
        },

        shareQzone: {
            fn: 'shareQzone',
            alias: 'share_qzone'
        },

        shareQqAppmsg: {
            fn: 'shareQqAppmsg',
            alias: 'share_qq_appmsg'
        },

        shareSinaWeibo: {
            fn: 'shareSinaWeibo',
            alias: 'share_sina_weibo'
        },
        shareFacebook: {
            fn: 'shareFacebook'
        },
        shareLine: {
            fn: 'shareLine'
        },
        shareWhatsApp: {
            fn: 'shareWhatsApp'
        },
        shareTwitter: {
            fn: 'shareTwitter'
        },
        shareEmail: {
            fn: 'shareEmail'
        },
        shareSMS: {
            fn: 'shareSMS'
        },

        getUserInfo: {
            fn: 'getUserInfo'
        },

        getSystemInfo: {
            fn: 'getSystemInfo'
        },

        getLocationInfo: {
            fn: 'getLocationInfo'
        },

        apolloGetToggle: {
            fn: 'apolloGetToggle'
        },

        refreshPage: {
            fn: 'refreshPage',
            alias: 'page_refresh'
        },

        closePage: {
            fn: 'closePage',
            alias: 'page_close'
        },

        openPage: {
            fn: 'openPage',
            alias: 'open_url'
        },
        clearCache: {
            fn: 'clearCache',
            support: '5.0.10'
        },
        launchScan: {
            fn: 'launchScan',
            support: '5.0.20'
        },
        requestLogin: {
            fn: 'requestLogin',
            alias: 'callNativeLogin',
            support: '5.0.10'
        },
        setTitle: {
            fn: 'setTitle',
            alias: 'updateNaviTitle',
            paramsAlias: 'navi_title'
        },
        photograph: {
            fn: 'photograph',
            support: '5.0.12'
        },
        commonPay: {
            fn: 'commonPay',
            alias: ['payByWX', 'payByAli'],
            support: '5.0.10'
        },
        launchNav: {
            fn: 'launchNav'
        },
        scanQRCode: {
            fn: 'scanQRCode'
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),

/***/ "sazR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONFIG; });
var CONFIG = {
  SYS_MODULE: ['TraceModule', 'DidiBridgeAdapter']
};

/***/ }),

/***/ "scgg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = callAndroid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("pMqq");

/**
 * prompt 封装, Andrid大于4.2.0版本均可以用
 *
 */


var theWindow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["getWindow"])();

var __uid = 0;

function callAndroid(fn, param, callback) {
  var id = __uid++;
  var callbackName = '__bridgeCall__' + id;

  var message = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    cmd: fn,
    id: id,
    params: param,
    callback: callbackName
  });

  theWindow[callbackName] = function (retData) {
    var errno = retData.errno;
    var err = null;
    if (errno !== __WEBPACK_IMPORTED_MODULE_1__util__["ERR_OK"]) {
      var msg = retData.errmsg;
      err = new Error(msg);
    }
    theWindow[callbackName] = function () {};
    // for beatles callback ret json string
    callback.length === 1 ? callback(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(retData.result)) : callback(err, retData.result);
  };

  theWindow.prompt(message);
};

// export const supportPrompt = isAndroid && compareVersion('>4.2.0');

/***/ }),

/***/ "tX21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initGlobalAPI;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__("pMqq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_old_bridge__ = __webpack_require__("DpXv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_bridge__ = __webpack_require__("SgM5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__beatles_index__ = __webpack_require__("mlBL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__app__ = __webpack_require__("SFol");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__share__ = __webpack_require__("7uB+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__is__ = __webpack_require__("jsdW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config__ = __webpack_require__("rpWB");
/**
 * 初始化全局api
 */



// 4.X版本重写makeBridgeFn




// 引入beatles bridge处理








var makeBridgeFunction = __WEBPACK_IMPORTED_MODULE_2__core_bridge__["a" /* makeBridgeFn */];



function initGlobalAPI(DDBridge) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__is__["a" /* initIS */])(DDBridge);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__app__["a" /* initApp */])(DDBridge);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_bridge__["b" /* init */])();
  initBaseCall(DDBridge);
  proxy(DDBridge);
  initSupport(DDBridge);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__share__["a" /* initShare */])(DDBridge);

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__app__["b" /* isFusionKit */])() && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__app__["c" /* compareAppVersion */])('<', '5.0.0')) {
    makeBridgeFunction = __WEBPACK_IMPORTED_MODULE_1__core_old_bridge__["a" /* oldMakeBridgeFn */];
    oldInitEvents(DDBridge);
  } else {
    initEvents(DDBridge);
  }

  // 初始化beatles扩展
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__beatles_index__["a" /* initBeatles */])(DDBridge);
};

/**
 * 基础的Bridge.call(name,param,callback)方法
 * @param DDBridge
 */
function initBaseCall(DDBridge) {
  DDBridge.call = function (name, param, callback) {
    var conf = __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].api[name];
    var bridgeFn = makeBridgeFunction(name, conf, __WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */]);
    if (!callback && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["isFn"])(param)) {
      callback = param;
      param = {};
    }
    return bridgeFn(param, callback);
  };
}

/**
 * 事件绑定接口
 * @param DDBridge
 */
function initEvents(DDBridge) {
  DDBridge.on = function (eventName, callback) {
    __WEBPACK_IMPORTED_MODULE_0__util__["events"].on(eventName, callback);
  };

  DDBridge.off = function (eventName, callback) {
    __WEBPACK_IMPORTED_MODULE_0__util__["events"].un(eventName, callback);
  };
}

function initSupport(DDBridge) {
  DDBridge.support = function (fn, cpVersion) {
    // 如果不是app或者该方法未收录,返回false
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__app__["d" /* inApp */])() || !DDBridge[fn]) {
      return false;
    }
    var support = DDBridge[fn].support;
    if (!support || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__app__["c" /* compareAppVersion */])(cpVersion || __WEBPACK_IMPORTED_MODULE_4__app__["e" /* app */].version, '>=', support)) {
      return true;
    }
    return false;
  };
}

/**
 * api接口代理, 只代理收录的方法
 * @param DDBridge
 */
function proxy(DDBridge) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["each"])(__WEBPACK_IMPORTED_MODULE_7__config__["a" /* default */].api, function (conf, name) {
    DDBridge[name] = makeBridgeFunction(name, conf);
    DDBridge[name].support = conf.support;
  });
}

function oldInitEvents(DDBridge) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__app__["f" /* isAndroid */])()) {
    DDBridge.on = function (eventName, callback) {
      __WEBPACK_IMPORTED_MODULE_0__util__["events"].on(eventName, callback);
    };

    DDBridge.off = function (eventName, callback) {
      __WEBPACK_IMPORTED_MODULE_0__util__["events"].un(eventName, callback);
    };

    DDBridge._trigger = __WEBPACK_IMPORTED_MODULE_0__util__["events"].emit;
  } else {
    DDBridge.on = __WEBPACK_IMPORTED_MODULE_1__core_old_bridge__["b" /* registerHandler */];

    DDBridge.off = __WEBPACK_IMPORTED_MODULE_0__util__["noop"];
  }
}

/***/ }),

/***/ "uhI5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bridgeCall;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

function schemeJump(url) {
  var iframe = document.createElement('iframe');
  iframe.src = url;
  iframe.style.display = 'none';
  document.documentElement.appendChild(iframe);
  setTimeout(function () {
    document.documentElement.removeChild(iframe);
  }, 0);
}

function bridgeCall(type, module, method, args) {
  var url = 'fusion://' + type + '?';
  if (module) {
    url += 'module=' + module + '&';
  }

  url += 'method=' + method + '&';
  var param = args.map(function (arg) {
    return encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(arg));
  });
  url += 'arguments=%5B' + param + '%5D&';

  // 添加host
  url += 'origin=' + window.location.hostname;

  schemeJump(url);
}

/***/ }),

/***/ "w+yi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = callIOS;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("pMqq");


var theWindow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["getWindow"])();

var schema = 'didibridge://BRIDGE_CALL?callback=';
var msgFrame = null;

var __uid = 0;

function callIOS(fn, param, callback) {
  var id = __uid++;
  var callbackName = '__bridgeCall__' + id;

  var callData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    cmd: fn,
    id: id,
    params: param,
    callback: callbackName
  });

  var callDataName = '__getCallData__' + id;
  theWindow[callDataName] = function () {
    theWindow[callDataName] = function () {};
    return callData;
  };

  theWindow[callbackName] = function (retData) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["isStr"])(retData)) {
      try {
        retData = JSON.parse(retData);
      } catch (e) {
        retData = {};
      }
    }
    var errno = retData.errno;
    var err = null;
    if (errno !== __WEBPACK_IMPORTED_MODULE_1__util__["ERR_OK"]) {
      var msg = retData.errmsg;
      err = new Error(msg);
    }
    theWindow[callbackName] = function () {};
    // for beatles callback ret json string
    callback.length === 1 ? callback(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(retData.result)) : callback(err, retData.result);
  };

  // do send
  var src = schema + callDataName;
  send(src);
};

function send(src) {
  if (!msgFrame) {
    msgFrame = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["createFrame"])(src);
  } else {
    msgFrame.src = src;
  }
}

/***/ }),

/***/ "y0Wx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isFunction;
/* unused harmony export isString */
/* unused harmony export isObject */
/* unused harmony export isJSON */
function typeEqual(obj, type) {
  return Object.prototype.toString.call(obj) === '[object ' + type + ']';
}

function isFunction(object) {
  return typeEqual(object, 'Function');
}

function isString(object) {
  return typeEqual(object, 'String');
}

function isObject(object) {
  return typeEqual(object, 'Object');
}

function isJSON(str) {
  if (isString(str)) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }
  return false;
}

/***/ }),

/***/ "zIJ9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return withFusion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isAndroid; });
/* unused harmony export isIOS */
/* harmony export (immutable) */ __webpack_exports__["a"] = getWindow;
var UA = getWindow().navigator.userAgent.toLowerCase();
var withFusion = /fusionkit/i.test(UA);
var isAndroid = /android/i.test(UA);

var isIOS = /iphone os/i.test(UA);

function getWindow() {
  var theWindow = window;
  var testCanGetTop = false;

  // 如果是在iframe内
  if (window.parent !== window) {
    // 通过try尝试是否可以取到top的属性，否则就是取不到 hack...
    try {
      testCanGetTop = window.top.document;
      testCanGetTop = true;
    } catch (e) {
      testCanGetTop = false;
    }
    if (testCanGetTop) {
      theWindow = window.top;
    }
  }
  return theWindow;
};

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/epower.7ee93c8340c29c22d597.js